// 📂 data/Talents.js
// Sample avatars (replace with real image paths later)
import avatar1Entry from "../images/chan.png";
import avatar1Mid from "../images/chan2.png";
import avatar1Senior from "../images/chan3.png";
import avatar2Entry from "../images/gametechentry.png";
import avatar2Mid from "../images/gametechmid.png";
import avatar2Senior from "../images/gametechsenior.png";
import avatar3Entry from "../images/billing1.png";
import avatar3Mid from "../images/billing2.png";
import avatar3Senior from "../images/billing3.png";
import avatar4Entry from "../images/3danimatorentry.png";
import avatar4Mid from "../images/3danimatormid.png";
import avatar4Senior from "../images/3danimatorsenior.png";
import avatar5Entry from "../images/artistentry.png";
import avatar5Mid from "../images/artistmid.png";
import avatar5Senior from "../images/artistsenior.png";
import avatar6Entry from "../images/gameartistentry.png";
import avatar6Mid from "../images/gameartistmid.png";
import avatar6Senior from "../images/gameartistsenior.png";
import avatar7Entry from "../images/2dartistentry.png";
import avatar7Mid from "../images/2dartistmid.png";
import avatar7Senior from "../images/2dartistsenior.png";
import avatar8Entry from "../images/UIEntry.png";
import avatar8Mid from "../images/UIMid.png";
import avatar8Senior from "../images/UISenior.png";
import avatar9Entry from "../images/unityEntry.png";
import avatar9Mid from "../images/unityMid.png";
import avatar9Senior from "../images/unitySenior.png";
import avatar10Entry from "../images/safetyEntry.png";
import avatar10Mid from "../images/safetyMid.png";
import avatar10Senior from "../images/safetySenior.png";

const role = [
  {
    talentId: "EXD-ARS-GAME-VCE-T1",
    role: "Game Account Recovery Support Agent",
    avatars: avatar1Senior,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 1",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Account Support", "Player Services"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To assist players in regaining access to their game accounts by handling routine login, password reset, and account recovery requests",
        "The agent will operate within a standardized workflow to authenticate player identity, guide through system-provided recovery tools, and escalate unresolved or suspicious access issues when necessary."
    ],
    coreCapabilities: [
        "Guiding users through password reset and recovery flows",
        "Authenticating player ownership using predefined scripts",
        "Addressing basic login errors and device sync concerns",
        "Documenting recovery steps and access outcomes",
        "Tagging and routing account escalation cases",
        "Educating players on two-factor authentication and account security",
        "De-escalating user frustration calmly and professionally",
    ],
    supportedWorkflows:[
        "Password reset via email or SMS verification",
        "Forgotten username or linked account retrieval",
        "Account locked after failed login attempts",
        "First-time login issues on new devices",
        "Basic recovery using security questions or registered data",
        "Instructions for 2FA setup and verification",
        "Recovery of accounts with limited previous activity",
        "Flagging suspected account compromise for Tier 2 escalation",
    ],
    keyDeliverables: [
        "≥ 85% CSAT (Customer Satisfaction Score)",
        "≥ 90% QA Compliance (authentication protocol and professionalism)",
        "≥ 95% Accuracy in Account Notes & Tagging",
        "≤ 10% Escalation Rate (Tier 1 boundary only)",
        "≤ 30 Seconds Average Speed to Answer (ASA – Voice)",
        "≤ 15 Minutes Average Handling Time (AHT – All channels)",
        "≥ 30 Recovery Cases Handled Daily (based on 8-hour shift)",
        "Note: These targets reflect Tier 1 benchmarks for casual and mobile game environments. Metrics may vary based on platform complexity and authentication policies. ",
    ],
    tierSummary: [
            "Handles routine account access issues through scripted recovery flows. Focuses on identity validation, recovery tool guidance, and login assistance. Escalates only when account compromise or system restrictions are suspected.",   
            "Assists players with scripted recovery processes (password reset, standard login tools). Escalates unresolved or suspicious access concerns."  ,
            "Guides users through standard recovery protocols and password resets. Flags abnormal login attempts for review."
    ],
    typeofSupport: {
        Call : ["Used to walk players through recovery steps and real-time validation of access credentials."],
        Voice : ["Engaged for real-time de-escalation and assistance with failed login or device mismatch scenarios."],
        Email : ["Used for sending recovery links, documentation requests, or confirming recovery outcomes."],
    },
    primaryTools: [
        "Zendesk", "Freshdesk", "Zoho Desk", "Internal Account Lookup Tools", "Identity Verification Dashboards", "Google Workspace", "CRM Platforms"
    ],
    fileFormats: [
        "JPG", "PNG (IDs, Screenshots)", "TXT", "CSV", "Email Threads", "Account Logs"
    ],
    Plugins: [
        "Restricted to client-approved identity and access tools only", "No plugin installation or live backend editing"
    ],
    gameType: [
        "Mobile", "Browser", "PC Lite", "Clients"
    ],
    gameEngine: [
        "No direct access", "Familiarity with how login states persist across Unity, Unreal, or proprietary engines"
    ],
    versionControl: [
        "Slack", "Zoho Cliq", "Microsoft Teams", "Internal notes", "Ticket tag handoff", "No Git or source control access"
    ],
    communication: [
        "Calm and empathetic", "Privacy-aware phrasing", "Clear security alignment", "Scripted ID check adherence", "Player-first language"
    ],
    workEthic: [
        "Security-minded", "Process-oriented", "Discreet", "Patient", "Trustworthy", "Maintains data confidentiality"
    ],
    hardSkills: [
        "Account verification workflows", "Ticketing systems", "Tagging and audit compliance", "Recovery platform navigation", "Typing speed ≥ 40 WPM"
    ],
    genre: [
        "Casual", "RPG", "Simulation", "Social", "Puzzle"
    ],
    shiftAvailability: [
        "Day", "Night", "Weekends", "Holidays", "Global login coverage hours"
    ],
    workScheduleFlexibility: [
        "Coverage during login surges", "Password reset campaigns", "System update-induced login errors", "Time-sensitive recovery support"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-ARS-GAME-VCE-T2",
    role: "Game Account Recovery Support Agent",
    avatars: avatar1Mid,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 2",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Account Support", "Player Services"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To resolve escalated account recovery issues requiring manual verification, ownership validation, or investigation of possible account compromise.",
        "Tier 2 agents handle high-sensitivity cases by balancing secure protocols with empathy, and serve as the central contact for flagged access problems, policy exceptions, or recovery disputes."
    ],
    coreCapabilities: [
        "Manual identity validation based on account history",
        "Handling flagged and high-risk recovery requests",
        "Investigating suspected account compromise",
        "Escalating confirmed hijackings or system errors",
        "Communicating policy-aligned resolutions",
        "Reviewing and verifying ownership claims",
        "Documenting escalations for audit readiness",
        "Providing feedback loops to Tier 1 on invalid recoveries"
    ],
    supportedWorkflows:[
        "Accounts locked due to multiple failed login attempts",
        "Recovery of accounts accessed from unauthorized locations",
        "Multi-platform login conflict review (email, Facebook, Apple, Google)",
        "Investigation of compromised accounts or behavioral flags",
        "Manual override requests (with client or moderation approval)",
        "Historical purchase verification for ownership validation",
        "Review of ID submissions or linked contact discrepancies",
        "Flagged access attempts from IP/location mismatches",
    ],
    keyDeliverables: [
        "≥ 88% CSAT — based on fairness and clarity in resolution",
        "≥ 92% QA Compliance — policy adherence and security protocol",
        "≥ 98% Accuracy in Account Validation Notes & Tagging",
        "≤ 5% Escalation Rate to Tier 3 (for database/system issues only)",
        "≤ 30 Minutes Average Handling Time (AHT)",
        "≥ 20 Tier 2 Recovery Cases Closed Daily (adjusted by case complexity)",
        "Note:  KPIs reflect secure account handling standards. Tier 2 metrics prioritize authentication quality, documentation, and resolution transparency over ticket volume.",
    ],
    tierSummary: [
            "Manages escalated recovery cases involving security flagging, manual identity review, compromised account investigations, and policy exceptions. Coordinates with moderation and risk teams.",   
            "Handles complex and manually verified recovery cases involving ownership disputes, compromised accounts, or system restrictions. Communicates decisions with clarity and care."  ,
            "Resolves moderate-risk recovery cases involving manual verification, ID checks, and account sync concerns."
    ],
    typeofSupport: {
        Call : ["Used for manual identity checks, user clarification, or live recovery resolution."],
        Voice : ["Applied in escalated support interactions requiring real-time ownership verification."],
        Email : ["Used for document submissions, verification results, and post-resolution instructions."],
    },
    primaryTools: [
        "Zendesk", "Freshdesk", "Zoho Desk", "Identity Verification Systems", "CRM Platforms", "Recovery Audit Logs", "Google Workspace", "Fraud and Risk Portals (client-provided)"
    ],
    fileFormats: [
        "JPG", "PNG", "PDF", "TXT", "System Logs", "ID Documents", "Chat", "Email History Logs"
    ],
    Plugins: [
        "client-approved tools only", "No direct account or backend database editing", "Uses verified access tools for identity review"
    ],
    gameType: [
        "Mobile", "PC", "Cross-Platform with third party logins (e.g. Apple, Steam, Facebook)",
    ],
    gameEngine: [
        "No engine access", "Awareness of how authentication flows are integrated across Unity, Unreal, and proprietary platform"
    ],
    versionControl: [
        "Slack", "Zoho Cliq", "Microsoft Teams", "Case documentation platforms", "Internal escalation notes", "No Git or dev access"
    ],
    communication: [
        "Empathetic yet policy-focused", "Clear about limitations and outcomes", "Discreet", "Audit-ready phrasing", "Security-compliant tone"
    ],
    workEthic: [
        "Discreet", "Trustworthy", "Investigative", "Detail-oriented", "Calm under pressure", "Adheres to privacy and data protection protocols"
    ],
    hardSkills: [
        "Secure ID validation", "Manual case management", "Account history tracing", "Cross-platform credential investigation", "Typing speed ≥ 45 WPM"
    ],
    genre: [
        "RPG", "MMO", "Simulation", "Social Casual", "Competitive Games with Login Incentives"
    ],
    shiftAvailability: [
        "Day", "Night", "Weekends", "Holidays", "Escalation-hour rotation as needed"
    ],
    workScheduleFlexibility: [
        "Responsive during login outage windows", "Recovery surge events", "Suspicious activity monitoring spikes", "Campaign-related recovery demand"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-ARS-GAME-VCE-T3",
    role: "Game Account Recovery Support Agent",
    avatars: avatar1Entry,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 3",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Account Support", "Player Services"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To conduct deep-level investigation and resolution of complex account recovery cases tied to database-level inconsistencies, system integration failures, or high-risk security escalations.",
        "Tier 3 agents serve as the final escalation point for account recovery, collaborating with developers, infrastructure, security, and compliance teams to validate ownership and restore legitimate access."
    ],
    coreCapabilities: [
        "Advanced account traceability and data validation",
        "Investigation of systemic login/authentication issues",
        "Cross-database verification of user credentials and activity",
        "Direct coordination with dev and backend teams",
        "Resolution of OAuth integration breakdowns (Apple, Steam, etc.)",
        "Internal flag management and risk threshold interpretation",
        "Account restoration under platform or legal supervision",
        "Drafting postmortem reports and recovery security feedback"
    ],
    supportedWorkflows:[
        "Recovery cases involving account corruption or mislinked credentials",
        "Broken single sign-on (SSO) pathways or identity token mismatches",
        "Recovery from mass-compromise events or targeted hijacking attempts",
        "Manual rollback of authentication settings or linkage errors",
        "System downtime-related loss of account state",
        "API malfunction affecting recovery flows",
        "Disputed ownership involving deep system traces",
        "Compliance-tagged review cases with audit dependencies",
    ],
    keyDeliverables: [
        "≥ 92% Root-Cause Recovery Resolution (Tier 3-eligible cases)",
        "≥ 98% Accuracy in Recovery Audit Logs & Chain-of-Custody Notes",
        "≥ 95% Compliance in Access Policy & Risk Handling",
        "≤ 2% Re-escalation or Reopen Rate",
        "≤ 72 Hours Average Resolution Time (based on complexity tier)",
        "≥ 10 Critical Cases Closed per Week (adjusted for case depth)",
        "Note: Tier 3 KPIs focus on resolution quality, audit fidelity, and cross-functional impact, rather than ticket volume. Metrics are evaluated through internal QA and platform partner validation." 
    ],
    tierSummary: [
            "Handles high-risk recovery tied to systemic errors, backend validation mismatches, or database-level issues. Coordinates with developers, infrastructure teams, and compliance officers.",   
            "Resolves root-level account issues tied to database inconsistencies, broken authentication flows, or integration bugs. Works with development, compliance, or backend engineering.",
            "Handles platform-integrated recovery breakdowns, backend access issues, and security-sensitive escalations. Interfaces with engineering and legal to validate and restore legitimate ownership." 
    ],
    typeofSupport: {
        Call: ["Used for direct coordination with platform teams, fraud response, or executive support confirmations."],
        Voice: ["Engaged only for high-trust communication, including verification support or audit confirmations."],
        Email: ["Primary channel for secure documentation exchange, investigation summaries, and post-recovery updates."],
    },
    primaryTools: [
        "Internal Admin Panels", "Secure Account Trace Tools", "CRM Platforms", "OAuth Debuggers", "Jira", "Recovery Monitoring Dashboards", "Cloud Access Logs", "Security Event Trackers", "Google Workspace", "Platform Console"
    ],
    fileFormats: [
        "JSON", "LOG", "CSV", "TXT", "PDF (ID scans, audit records)", "API trace reports", "Email headers"
    ],
    Plugins: [
        "Limited to pre-approved, secure recovery and audit tools", "No unsupervised backend changes", "No third-party plugin installations"
    ],
    gameType: [
        "Mobile", "PC", "Cross-Platform", "Online games with SSO and federated login systems"
    ],
    gameEngine: [
        "No engine access", "Awareness of how authentication flows are integrated across Unity, Unreal, and proprietary platform"
    ],
    versionControl: [
        "Slack", "Microsoft Teams", "Jira", "Git (read-only access)", "Audit wikis", "Risk & Security Reporting Tools", "No direct codebase modifications"
    ],
    communication: [
        "Technically clear and security-conscious", "Fully compliant with data privacy", "Documentation-rich phrasing", "Precise in ownership validation communication",
    ],
    workEthic: [
        "Highly Discreet", "Audit-driven", "Legally compliant", "Technically proficient", "Patient", "Cross-functional communicator", "Handles confidential data with integrity"
    ],
    hardSkills: [
        "Cross-system traceability", "API-level validation", "Multi-ID reconciliation", "Account access chain auditing", "Backend recovery logic review", "Typing speed ≥ 45 WPM"
    ],
    genre: [
        "RPG", "MMO", "Competitive PvP", "Simulation", "Casual", "Games with long-term progression systems"
    ],
    shiftAvailability: [
        "Flexible for escalation queues", "Incident-response availability", "Weekend or post-deployment access reviews"
    ],
    workScheduleFlexibility: [
        "Live incident recovery", "Data sync rollback sessions", "Mass-login outage follow-ups", "Legal compliance or external partner response cycles"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-TS-GAME-VCE-T1",
    role: "Game Technical Support Specialist",
    avatars: avatar2Entry,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 1",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Technical Support", "Game Operation"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To deliver front-line technical support for players encountering client-side issues, providing real-time assistance through voice, chat, or email.",
        "The specialist is responsible for resolving common technical concerns using standardized workflows, ensuring accurate documentation, and escalating unresolved or high-complexity cases to higher tiers when necessary."
    ],
    coreCapabilities: [
        "Step-by-step technical troubleshooting",
        "Real-time communication via multiple channels",
        "Diagnostic script handling",
        "Customer empathy and de-escalation",
        "Proper use of knowledge base tools",
        "Basic system and connectivity troubleshooting",
        "Accurate documentation and tagging",
        "Tier-based escalation routing"
    ],
    supportedWorkflows:[
        "Launcher and update issues",
        "Installation and patch troubleshooting",
        "Connectivity issues (ping, lag, disconnects)",
        "Device compatibility checks (mobile/PC)",
        "Error message identification",
        "Password and account sync assistance",
        "Reporting suspected bugs via ticketing system",
        "Basic graphics or audio troubleshooting (Tier 1 scope)"
    ],
    keyDeliverables: [
        "≥ 85% CSAT (Customer Satisfaction Score)",
        "≥ 90% QA Compliance (script, tone, protocol)",
        "≥ 95% Accuracy in Notes, Logs, and Tagging",
        "≤ 10% Valid Escalation Rate",
        "≤ 45 Seconds Average Speed to Answer (Voice)",
        "≤ 20 Minutes Average Handling Time (AHT)",
        "≥ 25 Cases Handled Daily (across channels, 8-hour shift)",
        "Note: Metrics are based on Tier 1 benchmarks for casual and mid-complexity game environments. Client-specific adjustments may apply."
    ],
    tierSummary: [
            "First point of contact for routine technical concerns, following diagnostic flows to assist users with known issues and surface-level game disruptions. Focus is on speed, clarity, and issue categorization for escalation if required.",   
            "Handles scripted, high-volume technical concerns with defined resolutions. Focuses on symptom resolution and documentation of common device-level issues.",
            "Handles basic technical concerns using predefined troubleshooting flows. Focuses on volume, speed, and player satisfaction." 
    ],
    typeofSupport: {
        Call: ["Used for guided troubleshooting and live player support. Clear technical phrasing and accurate ticket logging required."],
        Voice: ["Real-time audio support for urgent concerns, with empathy and clear guidance."],
        Email: ["For asynchronous diagnostics, log file review, and detailed follow-ups."],
    },
    primaryTools: [
        "Zendesk", "Freshdesk", "Zoho Desk", "Zoho CRM", "Twilio", "Aircall",  "RingCentral",  "Google Workspace", "Microsoft Office", "Internal ticketing systems", "Knowledge base platforms"
    ],
    fileFormats: [
        "TXT", "CSV", "JPG", "PNG", "LOG", "Crash Reports", "Ticket Forms"
    ],
    Plugins: [
        "Pre-installed diagnostics tools only", "No plugin installation or backend access"
    ],
    gameType: [
        "Mobile", "Browser", "Lighweight PC Clients"
    ],
    gameEngine: [
        "Familiarity with Unity and Unreal crash behaviors (no direct engine access)"
    ],
    versionControl: [
        "Slack", "Microsoft Teams", "Zoho Cliq", "Tag-based ticket routing", "Internal notes only (No Git or Perforce access)"
    ],
    communication: [
        "Clear technical explanations", "Calm and empathetic tone", "Step-by-step guidance", "Script adherence", "Professional escalation phrasing"
    ],
    workEthic: [
        "Analytical", "Detail-oriented", "Calm under pressure", "Reliable", "Follows escalation procedures", "Accepts feedback well"
    ],
    hardSkills: [
        "CRM and ticketing systems", "Device & OS familiarity", "Diagnostic script execution", "Typing speed ≥ 40 WPM", "Log recording ", "Basic network troubleshooting"
    ],
    genre: [
        "Casual", "Idle", "Simulation", "Ligh RPG", "MOBA (non-competitive)"
    ],
    shiftAvailability: [
        "Day", "Night", "Weekend", "Holidays", "Rotationg or 24/7 shift availability"
    ],
    workScheduleFlexibility: [
        "Peak support coverage", "LiveOps readiness", "Patch-day staffing", "Rotating hours", "Launch event support"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-TS-GAME-VCE-T2",
    role: "Game Technical Support Specialist",
    avatars: avatar2Mid,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 2",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Technical Support", "Game Operation"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To manage escalated technical concerns that require investigative support, policy-informed judgment, or access to deeper diagnostic layers",
        "This specialist acts as a resolution hub between Tier 1 frontline agents and Tier 3 developer-side support, handling issues that involve recurring game bugs, platform conflicts, and elevated user account problems."
    ],
    coreCapabilities: [
        "Mid-level diagnostics and issue reproduction",
        "Log review and analysis",
        "Judgment-based troubleshooting decisions",
        "Policy-aware player communication",
        "Documentation of edge-case technical issues",
        "Guidance to Tier 1 on recurring trends",
        "Liaison with QA, moderation, and platform teams",
        "Escalation refinement and tagging accuracy"
    ],
    supportedWorkflows:[
        "Recurring client-side crashes and instability",
        "In-game progress loss due to sync or save errors",
        "Payment and entitlement disputes with technical causes",
        "Ban appeals with device or system conflict claims",
        "Unresolved connectivity or asset loading failures",
        "Multi-device desync issues (cross-platform)",
        "Manual adjustment approvals and refund workflows",
        "Analysis of crash logs and user reports",
    ],
    keyDeliverables: [
        "≥ 88% CSAT — reflecting higher sensitivity case handling",
        "≥ 92% QA Compliance — issue judgment, tone, and documentation",
        "≥ 98% Accuracy in Technical Logs & Escalation Tags",
        "≤ 8% Escalation Rate to Tier 3",
        "≤ 30 Minutes Average Handling Time (AHT)",
        "≥ 20 Tier 2 Cases Handled per Day (8-hour shift)",
        "Note: KPIs are based on Tier 2 standards for moderate to complex support queues, particularly in live-operated and competitive game titles."
    ],
    tierSummary: [
            "Handles recurring or escalated issues requiring advanced platform knowledge, manual fixes, or analysis of client-side logs. Supports adjustments and coordination with QA or moderation teams.",   
            "Supports investigations into unresolved technical cases. Applies platform policies, interprets system behavior, and provides intermediate resolution paths. Bridges Tier 1 and backend teams through documentation, judgment, and escalated handling.",
            "Manages unresolved or recurring issues requiring intermediate diagnostics and manual case management. Coordinates across moderation and policy teams." 
    ],
    typeofSupport: {
        Call: ["Live diagnostics and urgent incident confirmation with empathy and detail."],
        Voice: ["Used to de-escalate player concerns tied to complex technical loss or disruptions."],
        Email: ["Preferred for documentation-heavy cases involving logs, screenshots, and follow-up tickets."],
    },
    primaryTools: [
        "Zendesk", "Freshdesk", "Zoho Desk", "Zoho CRM", "Twilio", "RingCentral",  "Google Workspace", "Microsoft Office", "Internal diagnostic and moderation tools", "Reporting dashboards"
    ],
    fileFormats: [
        "LOG", "CSV", "JSON", "Screenshot files", "Error codes", "Tracebacks", "Email threads"
    ],
    Plugins: [
        "Access to preset diagnostic and moderation tools ", "No core engine access", "No plugin authoring"
    ],
    gameType: [
        "Mobile", "PC", "Cross-Platform Clients", "Browser-based apps"
    ],
    gameEngine: [
        "Working familiarity with Unity and Unreal bug reports", "No direct access to development environments"
    ],
    versionControl: [
        "Slack", "Microsoft Teams", "Zoho Cliq", "Internal documentation", "Shared case notes", "No Git or source Perforce access"
    ],
    communication: [
        "Clear technical phrasing", "Case-sensitive empathy", "Platform-aligned tone", "De-escalation under pressure", "Technical-to-player language bridging"
    ],
    workEthic: [
        "Analytical", "Consistent", "Process-driven", "Accountable", "Calm under pressure", "Communicative across teams", "SOP Compliant"
    ],
    hardSkills: [
        "Log analysis", "CRM escalation workflows", " Root cause correlation", "QA coordination", "Tag-based documentation", "Tiered case routing", "Typing speed ≥ 45 WPM"
    ],
    genre: [
        "RPG", "Strategy", "Shooter", "MOBA", "Casual LiveOps Titles", "Sandbox Multiplayer"
    ],
    shiftAvailability: [
        "Day", "Night", "Weekend", "Holidays", "Rotation-based with escalation coverage"
    ],
    workScheduleFlexibility: [
        "LiveOps escalation support", "Hotfix monitoring shifts", "Peak volume response", "Launch-related surge availability"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-TS-GAME-VCE-T3",
    role: "Game Technical Support Specialist",
    avatars: avatar2Senior,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 3",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Technical Support", "Game Operation"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To conduct advanced technical diagnostics, system-level investigations, and collaborative troubleshooting with QA, development, and platform operations teams.",
        "The specialist manages high-impact escalations, executes in-depth analysis of backend logs and crash data, and helps maintain platform stability through critical incident handling and technical documentation."
    ],
    coreCapabilities: [
        "Root-cause analysis of persistent game-side issues",
        "Review of backend logs, error codes, and telemetry",
        "Bug replication and submission using dev-approved tools",
        "Creation of technical postmortems for major incidents",
        "Coordination with developers, QA, and infrastructure teams",
        "Tracking and documenting systemic technical trends",
        "Providing resolution feedback to Tier 1 and Tier 2",
        "Ensuring compliance with security and data access protocols",
    ],
    supportedWorkflows:[
        "Analysis of crash dumps and tracebacks",
        "Verification of known bugs and edge-case behaviors",
        "Infrastructure-related latency or server down reports",
        "Deep-dive investigation of gameplay-affecting anomalies",
        "Integration testing for client patch regressions",
        "Tools-based diagnostics (e.g., log collectors, monitoring scripts)",
        "Pre-release environment replication (sandbox or staging)",
        "Partnering with developers to resolve engine or database issues"
    ],
    keyDeliverables: [
        "≥ 90% Technical Case Resolution Rate (excluding root-cause code fixes)",
        "≥ 95% QA Audit Score on Documentation and Debugging Accuracy",
        "≥ 99% Tagging Precision and Technical Detail Compliance",
        "≤ 5% Re-escalation Rate",
        "≤ 3 Business Days Average Resolution Time (dependent on incident type)",
        "≥ 15 Tier 3 Tickets Processed Weekly (based on complexity and tools)",
        "Note: Tier 3 metrics prioritize resolution quality, documentation integrity, and systemic feedback. Timelines may flex based on incident criticality and development coordination."
    ],
    tierSummary: [
            "Focuses on root-cause analysis, bug replication, and environment-level diagnostics. Collaborates with game engineers or developers to investigate system-side defects or release-impacting issues.",   
            "Conducts advanced technical forensics, log parsing, and root cause investigations. Involves system-level bug reproduction, infrastructure analysis, and coordination with game engineers or DevOps.",
            "Investigates infrastructure-level, engine-integrated, or persistent bugs. Operates as the bridge between the support team and game developers for technical root-cause correction and live system assurance." 
    ],
    typeofSupport: {
        Call: ["Used in coordination sessions with internal stakeholders or emergency debriefs."],
        Voice: ["Applied for developer coordination or high-sensitivity client follow-up."],
        Email: ["Standard for log sharing, technical reports, and diagnostic transcripts."],
    },
    primaryTools: [
        "Jira" , "Zendesk" , "Zoho Desk" , "Crashlytics" , "Firebase" , "Unity Console" , "Unreal Insights" , "Charles Proxy" , "Postman" , "Monitoring dashboards" , "Google Workspace" , "Log aggregators" , "QA platforms"
    ],
    fileFormats: [
        "LOG", "DMP", "JSON", "XML", "CSV", "Screenshot & screen capture files", "Git-tracked debug notes", "API test scripts"
    ],
    Plugins: [
        "Access to sandbox tools, QA dashboards, and monitoring plugins only. No live backend changes. Dev-authorized plugin use only."
    ],
    gameType: [
        "Mobile", "PC", "Console", "Cross-Platform LiveOps Titles"
    ],
    gameEngine: [
        "Operational understanding of Unity, Unreal, and proprietary engines. No direct editing; access limited to sandbox and diagnostic consoles."
    ],
    versionControl: [
        "Slack", "Microsoft Teams", "Internal Dev Tools", "QA Wikis", "Git Read-only Access", "Jira Integration", "Technical war room environments"
    ],
    communication: [
        "Clear technical articulation", "Debugging-oriented phrasing", "Cross-team collaboration fluency", "Written precision for dev-side consumption"
    ],
    workEthic: [
        "Technically rigorous", "Persistent ", "Systems-thinker", "Secure access-compliant", "Developer-liaison mindset", "Process improvement-oriented"
    ],
    hardSkills: [
        "Log parsing", "Bug Tracking systems", "Scripting for test cases", "Dev console familiarity", "Cross-platform issue mapping", "Root-cause traceability"
    ],
    genre: [
        "RPG", "MMO", "Strategy", "MOBA", "Simulation ", "Competitive PvP", "Narrative-driven"
    ],
    shiftAvailability: [
        "Day", "Night", "Weekend", "Holidays", "Rotation-based with escalation coverage"
    ],
    workScheduleFlexibility: [
        "Hotfix and patch testing shifts", "Outage or incident support", "Release-window alignment", "Real-time monitoring availability"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
//   ------Game Billing & Payments Support Agent----------------------------------------------------------------------------------------------------------------------------------------------------------
  {
    talentId: "EXD-BPS-GAME-VCE-T1",
    role: "Game Billing & Payment Support Agent",
    avatars: avatar3Entry,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 1",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Billing Support", "Player Support Operations"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To handle front-line billing and payment inquiries from game players, including purchase verification, transaction failures, and refund eligibility.",
        "The agent will operate within Tier 1 scope, following standard payment support flows, assisting players via voice, chat, or email, and escalating complex financial disputes or fraudulent transactions as required."
    ],
    coreCapabilities: [
        "Identifying and resolving common payment issues",
        "Verifying recent purchases and billing records",
        "Assisting players with failed or duplicate transactions",
        "Providing refund and entitlement guidance within policy limits",
        "Explaining virtual currency or subscription terms",
        "Escalating flagged or sensitive cases for review",
        "Documenting payment interactions accurately",
        "Maintaining financial data confidentiality"
    ],
    supportedWorkflows:[
        "Missing item after successful purchase",
        "Double charges or billing confirmation mismatches",
        "Purchase not received due to connectivity or sync errors",
        "In-app payment failure (Google, Apple, Steam, etc.)",
        "Refund eligibility review using policy script",
        "Prepaid card or voucher support",
        "Region-specific currency or tax questions",
        "Purchase logs and receipt upload guidance",
    ],
    keyDeliverables: [
        "≥ 85% CSAT (Customer Satisfaction Score)",
        "≥ 90% QA Score (billing flow accuracy and tone)",
        "≥ 98% Accuracy in Payment Notes & Tagging",
        "≤ 10% Escalation Rate (Tier 1 threshold only)",
        "≤ 30 Seconds Average Speed to Answer (ASA – Voice)",
        "≤ 18 Minutes Average Handling Time (AHT – All channels)",
        "≥ 30 Inquiries Handled Daily (8-hour shift average)",
        "Note: Metrics reflect Tier 1 expectations for billing support in casual and mobile game environments. Adjustments may apply based on platform complexity or player base."
    ],
    tierSummary: [
            "Handles basic billing questions, missing item reports, and routine payment verifications. Follows strict policy adherence and predefined flows for refunds, receipts, and virtual item delivery.",   
            "Handles common billing concerns using fixed refund rules, receipt validation, and store policy scripts. Refers disputed or unauthorized transactions to Tier 2.",
            "Resolves standard billing issues including failed purchases, missing items, and basic refund eligibility questions. Uses scripts and store policy tools." 
    ],
    typeofSupport: {
        Call: ["Ideal for resolving billing confusion, refund explanations, and missing purchase recovery."],
        Voice: ["Used to guide players through account/payment verification processes."],
        Email: ["Standard for sending receipts, proof of purchase, and documenting sensitive or escalated payment issues."],
    },
    primaryTools: [
        "Zendesk", "Zoho Desk", "Freshdesk", "Stripe Dashboard (view-only)", "App Store & Play Store consoles (client-provided)", "Google Workspace", "Payment reconciliation tools", "CRM Platforms"
    ],
    fileFormats: [
        "JPG", "PNG", "PDF (receipts)", "TXT", "CSV", "Payment logs", "Ticket history"
    ],
    Plugins: [
        "No payment processing authority", "View-only dashboard or internal tools access", "No plugin installations"
    ],
    gameType: [
        "Mobile", "Browser", "Light Client games with in-app or in-platform purchases"
    ],
    gameEngine: [
        "No engine access required; surface-level understanding of store-based item delivery logic (Unity/Unreal optional knowledge)"
    ],
    versionControl: [
        "Slack", "Zoho Cliq", "Microsoft Teams", "Internal case notes", "Tag-based routing", "No Git or Dev tools"
    ],
    communication: [
        "Empathetic", "Financially neutral phrasing", "Policy-aligned responses", "Clear escalation handoff", "Brand voice for sensitive topics"
    ],
    workEthic: [
        "Discreet" , "Accuracy-focused" , "Follows billing protocols" , "Patient" , "Maintains data confidentiality" , "Resolves under pressure"
    ],
    hardSkills: [
        "Billing system navigation", "Ticketing workflows", "Refund eligibility verification", "Escalation tagging", "Typing speed ≥ 40 WPM", "Policy flow execution"
    ],
    genre: [
        "Casual", "Puzzle", "Simulation", "Light RPG", "Social"
    ],
    shiftAvailability: [
        "Day", "Night", "Weekend", "Holidays", "24/7 billing queue coverage as needed"
    ],
    workScheduleFlexibility: [
        "Billing cycle peaks" ,"Platform outage response" , "Seasonal purchase surges" , "Event-based purchase support windows"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-BPS-GAME-VCE-T2",
    role: "Game Billing & Payment Support Agent",
    avatars: avatar3Mid,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 2",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Technical Support", "Game Operation"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To handle escalated billing and payment cases that require deeper investigation, policy interpretation, or coordination with third-party platforms (e.g., Apple, Google, Steam).",
        "Tier 2 agents are trained to manage transaction disputes, validate refund exceptions, assess fraud reports, and deliver fair, policy-aligned resolutions while preserving trust and operational accuracy."
    ],
    coreCapabilities: [
        "Transaction discrepancy analysis",
        "Platform liaison (App Store, Play Store, Steam, Stripe, etc.)",
        "Refund and chargeback resolution",
        "Cross-platform entitlement verification",
        "Policy interpretation and case-by-case judgment",
        "Secure data review and fraud flag handling",
        "Case documentation with escalation traceability",
        "Feedback to Tier 1 teams on billing patterns and workflows",
    ],
    supportedWorkflows:[
        "Unauthorized or fraudulent transaction review",
        "Chargeback response and account impact explanation",
        "Third-party billing report reconciliation",
        "Manual refund or adjustment under defined thresholds",
        "Delayed entitlement or currency delivery across platforms",
        "Review of subscription auto-renewal complaints",
        "Coordination with finance, trust & safety, or legal support",
        "Region-specific billing error resolution (e.g., VAT discrepancies)"
    ],
    keyDeliverables: [
        "≥88% CSAT — focused on fairness and resolution quality",
        "≥ 92% QA Score — documentation, discretion, and policy alignment",
        "≥ 98% Accuracy in Refund Logs & Billing Tags",
        "≤ 5% Escalation Rate to Tier 3 or Finance/Admin",
        "≤ 30 Minutes Average Handling Time (AHT)",
        "≥ 18 Tier 2 Billing Cases Resolved Daily (8-hour shift)",
        "Note: Tier 2 benchmarks reflect mid-complexity case handling for global digital billing environments. Metrics may vary by platform volume and policy complexity."
    ],
    tierSummary: [
            "Manages escalated cases requiring platform liaison (e.g., Apple/Google), discretionary compensation, suspected fraud, or chargeback response. Coordinates with finance and trust/safety teams.",   
            "Manages platform-based disputes, cross-account purchases, and manual review workflows. Applies billing policies with judgment and collaborates with moderation and finance as needed.",
            "Manages escalated financial cases such as chargebacks, platform errors, and unauthorized purchases. Uses discretionary policy judgment and coordinates with moderation and support leads." 
    ],
    typeofSupport: {
        Call: ["Utilized for sensitive cases involving account bans, fraud flags, or refund explanations."],
        Voice: ["Engages players directly when judgment-based clarification is needed for escalated transactions."],
        Email: ["Essential for sending supporting documentation, detailed refund conclusions, and transaction history breakdowns."],
    },
    primaryTools: [
        "Zendesk", "Freshdesk", "Zoho Desk", "Zoho CRM", "Stripe (client-linked)", "App Store Connect",  "Google Play Console", "Jira (view-only)", "Internal refund dashboards", "Payment verification systems", "Google Workspace"
    ],
    fileFormats: [
        "PDF", "CSV", "JPG", "PNG", "Transaction records", "Email threads", "System-generated logs"
    ],
    Plugins: [
        "Limited to secure billing tools provided by client", "No live transaction execution", "No backend financial tool development"
    ],
    gameType: [
        "Mobile", "Cross-Platform Clients", "Browser", "Console-linked digital purchases"
    ],
    gameEngine: [
        "No direct access required; understanding of currency conversion and platform-purchase pipelines across Unity, Unreal, or proprietary engines"
    ],
    versionControl: [
        "Slack", "Zoho Cliq", "Microsoft Teams", "Ticket tagging", "Internal collaboration notes", "No direct Git access"
    ],
    communication: [
        "Balanced and clear", "Empathetic with firm policy adherence", "Skilled at de-escalation", "Sensitive to financial concerns", "Brand-aligned phrasing for denial or partial refund cases"
    ],
    workEthic: [
        "Policy-precise", "Honest and discreet", "Audit-compliant", "Analytical", "Customer-sensitive", "Trustworthy with finance-linked cases"
    ],
    hardSkills: [
        "Billing platform navigation", "Escalation routing", "Case-by-case refund handling", "Report writing", "Tag-based documentation", "Chargeback documentation", "Typing speed ≥ 45 WPM"
    ],
    genre: [
        "LiveOps Titles", "Casual", "RPG", "Strategy", "Simulation", "Competitive games with in-game purchases"
    ],
    shiftAvailability: [
        "Flexible", "Escalation queue alignment", "Weekend and holiday shifts", "Rotational support accross time zones"
    ],
    workScheduleFlexibility: [
        "Supports payment surge periods" , "Refund campaigns" , "Platform outage spikes" , "End-of-month reconciliation shifts"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "EXD-BPS-GAME-VCE-T3",
    role: "Game Billing & Payment Support Agent",
    avatars: avatar3Senior,
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 3",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Technical Support", "Game Operation"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: " 6 months",
    deploymentTimeline: " ",
    roleObjective: [
        "To investigate complex and systemic payment issues involving backend platform inconsistencies, financial system integrations, fraud intelligence signals, and high-sensitivity purchase disputes.",
        "Tier 3 agents serve as escalation gatekeepers for billing operations and collaborate with platform providers, finance teams, and development engineers to ensure transactional integrity and player trust."
    ],
    coreCapabilities: [
        "Backend purchase flow verification",
        "Cross-system data mapping (user ID, platform ID, entitlement records)",
        "Infrastructure-level payment sync reviews",
        "Fraud escalation and analysis support",
        "Developer liaison for platform and entitlement bugs",
        "Incident-level reporting for finance and security teams",
        "Chargeback pattern identification and flagging",
        "Transactional system logs review and trend reporting"
    ],
    supportedWorkflows:[
        "High-value or cross-region transaction failures",
        "Systemic entitlement delivery bugs or delays",
        "Multi-platform wallet sync failures",
        "Double charge investigations tied to infrastructure latency",
        "Purchase reversals caused by backend reconciliation bugs",
        "Fraud ring detection and account behavior correlation",
        "Manual resolution of developer-side missing purchases",
        "Root-cause tracing of platform payout anomalies"
    ],
    keyDeliverables: [
        "≥ 92% Root-Cause Resolution Accuracy (within Tier 3 scope)",
        "≥ 95% Compliance in Security & Payment Data Handling",
        "≥ 99% Accuracy in Transaction Mapping & Tagging",
        "≤ 3% Re-escalation Rate to Dev or Finance Leadership",
        "≤ 72 Hours Average Resolution Time (depending on severity)",
        "≥ 12 Complex Case Closures Weekly (variable based on case type)",
        "Note: Tier 3 billing metrics prioritize forensic accuracy, cross-team resolution, and platform-level integrity over high ticket volume. Timelines adjust per investigation depth."
    ],
    tierSummary: [
            "Supports root-cause payment investigations tied to backend infrastructure, system-wide platform sync issues, or large-scale transactional disruptions requiring developer and financial system coordination.",   
            "Investigates infrastructure-wide payment anomalies, system bugs in entitlement delivery, and partners with developers or financial engineers on backend failures and payment flow logic.",
            "Investigates technical breakdowns in the billing system pipeline, backend entitlement errors, infrastructure-related billing bugs, and fraud trends. Collaborates with finance, platform, and development teams for permanent resolution." 
    ],
    typeofSupport: {
        Call: ["Used in interdepartmental sessions, technical debriefs, or fraud investigation interviews."],
        Voice: ["Escalated usage only—primarily for executive client-side updates or internal collaboration."],
        Email: ["Primary channel for secure document exchange, transaction analysis, audit trails, and reporting summaries."],
    },
    primaryTools: [
        "Jira" , "Zendesk" , "Zoho Desk" , "Stripe Dashboard", "App Store Connect", "Google Play Console", "Internal Audit Tools", "Backend Logging Systems", "Tableau or Looker (view access)", "QA Dashboards", "Finance Portals"
    ],
    fileFormats: [
        "CSV" , "JSON" , "PDF" , "Internal billing logs" , "Error trace files" , "Git-tracked payment logic notes" , "Screenshot & audit attachments"
    ],
    Plugins: [
        "Access to client-authorized audit tools and payment systems only", "No plugin installation or live code modification"
    ],
    gameType: [
        "Cross-platform", "LiveOps-based mobile and PC titles", "Marketplace-integrated games"
    ],
    gameEngine: [
        "Advanced familiarity with entitlement pipeline behaviors in Unity, Unreal, or proprietary engines (via logs and internal tools; no direct edit access)"
    ],
    versionControl: [
        "Slack", "Microsoft Teams", "Internal Financial Notes", "Jira", "Git (read-only or tags)", "Shared fraud & finance dashboards"
    ],
    communication: [
        "Technically precise" , "Professional and discreet" , "Escalation-appropriate tone" , "Audit-ready documentation" , "Cross-team report alignment"
    ],
    workEthic: [
        "Highly analytical" , "Data integrity-focused" , "Audit-compliant" , "Proactive" , "Confidentiality-bound" , "Trusted in high-stakes resolution"
    ],
    hardSkills: [
        "Cross-system payment tracing" , "API response interpretation" , "Chargeback fraud analytics" , "Developer coordination" , "Tagging for billing infrastructure" , "Typing speed ≥ 45 WPM"
    ],
    genre: [
        "RPG", "MMO", "Casual Competitive", "Simulation", "Gacha", "Subscription-based platforms"
    ],
    shiftAvailability: [
        "Flexible coverage for critical incident handling", "Aligned with finance or platform partner availability", "24/7 rotation-ready if required"
    ],
    workScheduleFlexibility: [
        "Incident-based surge coverage" , "Refund wave audit shifts" ,"Financial quarter reconciliation support" ,"Platform outage response readiness"
    ],
    inclusions: [
        " "
    ],
    deploymentEngagement: [
        " "
    ],
  },
  //   ------3D Artist (Generalist)----------------------------------------------------------------------------------------------------------------------------------------------------------
  {
    talentId: "3D-ART-E",
    role: "3D Artist (Generalist)",
    avatars: avatar5Entry,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Entry",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creattive", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Assist in the creation and refinement of 3D assets including props, characters, and environments by following established visual guidelines and modeling standards. Apply core principles in modeling, UV mapping, and texturing while collaborating with art leads and cross-functional teams. Contribute to the visual pipeline by maintaining clean geometry, adhering to export requirements, and supporting asset integration"
    ],
    coreCapabilities: [
        "Foundational skills in modeling, UV unwrapping, and basic texturing",
        "Ability to work with low to mid-poly pipelines for games and interactive content",
        "Familiarity with naming conventions, topology control, and file organization",
        "Adaptability to feedback and evolving visual targets",
        "Understanding of 3D file preparation for engine export and version control"
    ],
    supportedWorkflows:[
        "Receives tasks via ClickUp,Project Zoho, or other Agile boards",
        "Submits files through structured version-controlled folders (e.g., GDrive, Github)",
        "Participates in sprint reviews and internal asset critiques",
        "Follows asset naming conventions, export settings, and handoff documentation",
        "Collaborates with rigging and animation when applicable"
    ],
    keyDeliverables: [
        "Low-to-mid poly props or environment pieces: 2 < 4 / week",
        "Base character or creature sculpts (entry or modular): 1 < 2 / week",
        "UVs and baking setup: 1 < 3 / task",
        "Textured asset exports (game-ready): 1 < 2 / week",
        "Properly structured folders and files: 100% compliance",
        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Supports 3D asset creation by modeling simple props, organizing files, and applying feedback under supervision.",   
            "Builds technical foundations in modeling and UV layout using Blender, Maya, or 3ds Max.",
            "Submits clean files with proper naming and receives mentorship and documentation access." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Autodesk Maya", "Blender"
    ],
    fileFormats: [
        ".FBX", ".OBJ", ".MB", ".BLEND"
    ],
    Plugins: [
        "Quad Remesher", "UV Toolkit", "Substance Bridge"
    ],
    gameType: [
        "Casual", "Stylized", "Mobile"
    ],
    gameEngine: [
        "Basic export to Unity and Unreal"
    ],
    versionControl: [
        "Github", "Google Workspace", "ClickUp"
    ],
    communication: [
        "Gives regular updates, responds well to direction (Slacks, Discord, Microsoft Teams, Gmeet)"
    ],
    workEthic: [
        "Detail-oriented" , "responsive" , "open to mentoring and iterative improvements"
    ],
    hardSkills: [
        "Low-poly modeling", "UV unwrapping", "basic texturing", "mesh cleanup"
    ],
    genre: [
        "Fantasy", "Sci-Fi", "Cartoony (Depends on Client request in scope)"
    ],
    shiftAvailability: [
        "Day shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project alignment needs)"
    ],
    inclusions: [
        "Up to 2–3 revision rounds per asset",
        "Supervised onboarding to modeling pipeline and naming conventions",
        "Assigned to basic modeling, UV layout, and scene clean-up tasks",
        "Access to starter topology samples and file structuring templates",
        "Participation in team stand-ups, review cycles, and peer mentoring opportunities"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "3D-ART-M",
    role: "3D Artist (Generalist)",
    avatars: avatar5Mid,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Mid",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Independently produce polished 3D assets including characters, props, and modular environments aligned with client or project style guides. Apply industry-standard practices in topology, UV layout, and texturing to ensure game-ready and engine-compatible deliverables. Collaborate across departments and support junior artists while maintaining pipeline efficiency and visual quality."
    ],
    coreCapabilities: [
        "Strong proficiency in mid-to-high poly modeling, UV mapping, and texturing",
        "Clean and optimized topology, LOD preparation, and export readiness",
        "Skilled in baking maps and preparing PBR materials for various engines",
        "Consistently follows asset naming conventions and workflow guidelines",
        "Capable of mentoring entry-level artists and reviewing peer assets"
    ],
    supportedWorkflows:[
        "Operates independently within ClickUp, Project Zoho, or sprint-based Agile pipelines",
        "Delivers through structured version control systems (Google Drive, Git, Perforce)",
        "Participates in internal reviews, sprints, and QA cycles with senior oversight",
        "Collaborates with rigging, concept, and technical art for asset integration",
        "Supports documentation updates and contributes to pipeline improvements",
    ],
    keyDeliverables: [
        "Game-ready environment modules or detailed props: 2 < 4 / week",
        "Mid-complexity characters or creatures (modeled + UVd): 1 < 2 / week",
        "Full UV unwraps and texture bakes: 2 < 3 / task",
        "Material + texture sets (PBR): 1 < 2 / week",
        "Engine-importable assets with naming/structure compliance: 100% adherence",
        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Delivers polished 3D assets independently, participates in art reviews, and maintains workflow compliance.",   
            "Proficient in sculpting, optimization, and engine-ready asset packaging.",
            "Provides feedback to junior artists, collaborates across teams, and supports documentation." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Autodesk Maya", "Blender", "ZBrush", "Substance Painter", "Marmoset Toolbag"
    ],
    fileFormats: [
        ".FBX", ".OBJ", ".BLEND", ".MA", ".SPSM", ".TGA"
    ],
    Plugins: [
        "UVPackmaster", "Texel Density Checker", "DecalMachine", "Substance Link"
    ],
    gameType: [
        "Mobile", "PC", "Console", "VR/AR - modular", "stylized", "semi-realistic projects"
    ],
    gameEngine: [
        "Unity", "Unreal Engine (static-mesh setup, LOD preparation, lightmap configuration)"
    ],
    versionControl: [
        "Github", "Google Workspace", "ClickUp"
    ],
    communication: [
        "Proactive during sprint reviews; flags issues clearly and follows protocol (Discord, Slack and Microsoft Teams)"
    ],
    workEthic: [
        "Results-driven, adaptable, collaborative, and quality-conscious"
    ],
    hardSkills: [
        "Clean topology, UV packing, optimized bakes, modular asset execution"
    ],
    genre: [
        "Fantasy", "Sci-fi", "Cartoony (Depends on Client request in scope)"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Up to 3 feedback rounds per animation",
        "Direct access to art leads and animation critiques",
        "Internal documentation access for animation standards",
        "Task tracking via project board with delivery timelines"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "3D-ANIM-S",
    role: "3D Artist (Generalist)",
    avatars: avatar5Senior,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Senior",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino" , "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Lead the visual development and delivery of high-quality 3D assets across environments, characters, props, and modular kits. Ensure technical and artistic alignment with project direction, performance constraints, and client standards. Provide mentorship, quality assurance, and documentation support to optimize asset workflows and cross-functional collaboration."
    ],
    coreCapabilities: [
        "Advanced proficiency in sculpting, topology, UV workflows, and texturing",
        "Expert in optimization, modular workflows, and engine-readiness (Unity/Unreal)",
        "Applies creative leadership and reviews across art asset life cycle",
        "Ensures all outputs meet naming, export, and integration standards",
        "Communicates clearly across art, tech, and production teams"
    ],
    supportedWorkflows:[
        "Leads internal art reviews, style syncs, and milestone sign-offs",
        "Coordinates with rigging, animation, and tech for seamless handoff",
        "Uses full studio pipelines including Perforce, ClickUp, Miro, and asset version control",
        "Reviews file structure, naming compliance, and export-ready organization",
        "Supports sprint planning, QA reviews, and peer-level critique"
    ],
    keyDeliverables: [
        "Hero assets or key set pieces: 1 < 2 / week",
        "Advanced character/creature sculpts (with polish + texture): 1 / week",
        "Modular kit design or benchmark assets: 1 < 2 / milestone",
        "Mentorship & QA sign-off cycles: Weekly / per sprint",
        "Documentation or template updates: As needed per visual direction",
        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."  
    ],
    tierSummary: [
            "Leads complex asset production and visual development while ensuring cross-team alignment and consistency.",   
            "Expert in art pipelines, asset integration, and performance-conscious modeling.",
            "Approves deliverables, mentors team members, and improves visual standards and documentation." 
    ],
    typeofSupport: {
        Call: [""],
        Chat: [""],
    },
    primaryTools: [
        "Autodesk Maya", "Blender", "ZBrush", "Substance Suite", "Marmoset Toolbag"
    ],
    fileFormats: [
        ".FBX", ".OBJ", ".MA", ".BLEND", ".SPSM", ".TGA", ".EXR"
    ],
    Plugins: [
        "UVPackmaster", "DecalMachine", "Texel Density Checker", "Material Baker"
    ],
    gameType: [
        "Console", "PC", "Mobile", "VR/AR-complex", "high-fidelity", "modular or stylized"
    ],
    gameEngine: [
        "Unreal Engine (engine-ready export and integration testing)", "Unity"
    ],
    versionControl: [
        "Github", "Perforce", "Google Workspace", "ClickUp"
    ],
    communication: [
        "Leads team check-ins, flags blockers early, and presents visual solutions to clients or leads (Discord, Slack and Microsoft Teams)"
    ],
    workEthic: [
        "Strategic", "Detail-Driven", "Collaborative", "Capable of creative ownership"
    ],
    hardSkills: [
        "Advanced sculpting", "Mesh optimization", "Texture polish", "Modular kit design"
    ],
    genre: [
        "Realistic", "Stylized", "Fantasy", "Sci-fi", "Hard Surface (project dependent)"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Leads the production of hero assets, key visuals, and high-resolution sculpts",
        "Reviews and signs off on 3D outputs submitted by entry and mid-level artists",
        "Coordinates with project leads for visual style consistency and milestone QA",
        "Provides mentorship, training, and hands-on feedback to junior and mid artists",
        "Oversees or creates pipeline documentation, naming templates, and export guides",
        "May participate in client-side meetings, review presentations, or milestone showcases"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  //   ------3D Animator (Generalist)----------------------------------------------------------------------------------------------------------------------------------------------------------
  {
    talentId: "3D-ANIM-E",
    role: "3D Animator (Generalist)",
    avatars: avatar4Entry,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Entry",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creattive", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Assist in the creation of basic 3D animations by following pre-defined rigs and sequences under direct supervision. Learn and apply animation fundamentals aligned with project style and pacing requirements. Collaborate with senior animators through reviews and feedback cycles while building technical discipline."
    ],
    coreCapabilities: [
        "Foundational skills in keyframe animation, pose-to-pose, and timing",
        "Basic understanding of rig manipulation and motion blocking",
        "Willingness to learn animation pipelines and naming conventions",
        "Openness to feedback and consistent improvement",
        "Familiarity with organizing animation files and timelines"
    ],
    supportedWorkflows:[
        "Follows task-based direction using ClickUp or Project Zoho",
        "Submits files through version-controlled folders (Google Drive)",
        "Joins daily/weekly team check-ins, supervised by Animation Lead",
        "Follows naming conventions, file handoff formats, and delivery timelines"
    ],
    keyDeliverables: [
        "Idle or looped animations: 2 < 4 / week",
        "Basic action sequences (run, jump, interact): 1 < 2 / week",
        "Rig adjustment / cleanup tasks: 1 < 3 / task",
        "Feedback implementation rounds: 1 < 3",
        "Properly structured animation files: 100% compliance",
        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Assists in animating basic 3D sequences using pre-defined rigs, while receiving direct guidance from senior team members.",   
            "Builds foundational skills in animation timing, file organization, and rig handling using tools like Maya or Blender.",
            "Submits work through structured pipelines, applies mentor feedback, and adheres to naming conventions and delivery formats." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Autodesk Maya", "Blender"
    ],
    fileFormats: [
        ".FBX", ".MA", ".BLEND"
    ],
    Plugins: [
        "Basic animation tools (e.g., AutoTangent, Studio Library)"
    ],
    gameType: [
        "Casual", "Stylized", "Mobile"
    ],
    gameEngine: [
        "Basic exposure to Unity"
    ],
    versionControl: [
        "Github", "Google Workspace", "ClickUp"
    ],
    communication: [
        "Gives regular updates, responds well to direction (Slacks, Discord, Microsoft Teams, Gmeet)"
    ],
    workEthic: [
        "Disciplined", "Open to mentorship", "Receptive to feedback"
    ],
    hardSkills: [
        "Keyframing", "Idle Loops", "Basic motion blocking"
    ],
    genre: [
        "Fantasy", "Sci-fi", "Cartoony (Depends onb Client Request in scope)"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Up to 2 revision per animation",
        "Supervised onboarding and task guidance",
        "Simple rig usage documentation (if required)",
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "3D-ANIM-M",
    role: "3D Animator (Generalist)",
    avatars: avatar4Mid,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Mid",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Execute polished 3D animations with moderate complexity using industry-standard tools and pre-built rigs. Deliver animation-ready assets that align with gameplay, cinematic, or promotional intent. Contribute to planning, pacing, and quality control while coordinating with modeling and rigging teams."
    ],
    coreCapabilities: [
        "Intermediate animation fluency: weight, anticipation, follow-through",
        "Confident in camera animation, timing control, and technical setup",
        "Can troubleshoot rigs and adjust motion arcs independently",
        "Understands project constraints and optimizes animation efficiency",
        "Communicates clearly in feedback sessions and sprint planning"

    ],
    supportedWorkflows:[
        "Works semi-independently via agile board Click UP ",
        "Submits via cloud version control or repository (Google Drive, Git)",
        "Participates in sprint reviews and animation critiques",
        "Delivers with appropriate formats and naming protocols"
    ],
    keyDeliverables: [
        "Loop + interactive animations: 3 < 5 / week",
        "Gameplay sequences or cutscene segments: 1 < 2 / week",
        "Internal test renders or playblasts: 2 < 4 / task",
        "Iteration passes post-review: 1 < 2",
        "Exported files (FBX, Maya, etc.): 100% structured",
        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Delivers polished gameplay and cinematic animations independently while aligning with pacing, tone, and technical standards.",   
            "Uses tools like Maya and Blender efficiently, manages rig constraints, and ensures animations integrate well into game engines.",
            "Participates in sprint reviews, implements revisions efficiently, and provides input to enhance workflow or creative direction." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Autodesk Maya", "Blender", "Unity", "Unreal Engine"
    ],
    fileFormats: [
        ".FBX", ".MA", ".MB", ".BLEND", ".ANI"
    ],
    Plugins: [
        "Studio Library", "Motion path tools", "Custom scripting utilities"
    ],
    gameType: [
        "Casual", "Action", "AR/VR-ready animations", "Stylized", "Cinematic", "Mobile/PC"
    ],
    gameEngine: [
        "Unity", "Unreal"
    ],
    versionControl: [
        "Github", "Google Workspace", "Clickup"
    ],
    communication: [
        "Actively contributes in team calls and sprint discussions (Discord, Slack and Microsoft Teams)"
    ],
    workEthic: [
        "Self-managing", "Consistent", "Collaborative"
    ],
    hardSkills: [
        "Keyframe polish", "Secondary Motion", "Working with camera animation"
    ],
    genre: [
        "Fantasy", "Sci-fi", "Cartoony (Depends on Client request in scope)"
    ],
    shiftAvailability: [
        "Day shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Up to 3 feedback rounds per animation",
        "Direct access to art leads and animation critiques",
        "Internal documentation access for animation standards",
        "Task tracking via project board with delivery timelines"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "3D-ANIM-S",
    role: "3D Animator (Generalist)",
    avatars: avatar4Senior,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Senior",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Lead the execution and quality review of animation outputs across projects, ensuring adherence to visual style, pacing, and emotional weight.",
        "Provide mentorship to junior animators, optimize animation workflows, and liaise with rigging and tech art for smooth integration. Drive animation direction aligned with game design and narrative."
    ],
    coreCapabilities: [
        "Advanced animation principles: body mechanics, stylization, emotional expression",
        "Can break down narrative beats into animation flow and staging",
        "Familiar with integration into Unity/Unreal pipelines",
        "Proficient in tool development recommendations and rig improvement feedback",
        "Strong leadership, delegation, and client presentation capabilities"
    ],
    supportedWorkflows:[
        "Leads animation reviews, storyboarding sessions, and direction briefs",
        "Oversees file structure, submission flow, and QA sign-off",
        "Uses full project pipeline tools (Jira, Perforce, Miro, etc.)",
        "Collaborates with production and art leads across departments"
    ],
    keyDeliverables: [
        "Animation lead tasks and approvals: Daily / per milestone",
        "Final animation sequences (gameplay/cutscene): 1 < 2 / week",
        "Block-in to polish staging passes: 1 < 2 / shot",
        "Mentorship sessions or reviews: Weekly / per cycle",
        "Clean, deployable animation packages: 100% delivery-ready",

        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Oversees animation quality and drives visual storytelling across assets.",   
            "Fully proficient with tools, mentors others, and improves workflows.",
            "Provides direction, delivers feedback, and ensures technical and creative alignment" 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Adobe Photoshop", "Clip Studio Paint", "Krita", "Illustrator", "Procreate", "PureRef"
    ],
    fileFormats: [
        "PSD", "PNG", "JPG", "TIFF", "GIF", "SVG"
    ],
    Plugins: [
        "Perspective Tools", "Coolorus", "MagicPicker", "Lazy Nezumi", "BrushBox"
    ],
    gameType: [
        "Mobile", "PC", "Console", "Web-based", "Casual", "Midcore", "Hardcore"
    ],
    gameEngine: [
        "Unity", "Unreal Engine (for art asset integration, not UI)", "Godot"
    ],
    versionControl: [
        "Github", "Google Workspace", "Click Up"
    ],
    communication: [
        "Leads team discussions", "Provides feedback", "Presents to clients (Discord, Slack, and Microsoft Teams)"
    ],
    workEthic: [
        "Strategic thinker", "Collaborative", "Reliable", "Growth-oriented"
    ],
    hardSkills: [
        "Advanced body mechanics", "Facial animation", "Cinematic staging"
    ],
    genre: [
        "All (adaptable to project needs)"
    ],
    shiftAvailability: [
        "Day shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Oversees animation consistency across key deliverables",
        "Provides mentorship and supports onboarding of junior animators",
        "Leads or participates in direction briefs and style alignment meetings",
        "Responsible for final polish and sign-off on animation-ready assets",
    ],
    deploymentEngagement: [
        " "
    ],
  },
  //   ------Game Artist----------------------------------------------------------------------------------------------------------------------------------------------------------
  {
    talentId: "G-ART(2D/3D)-E",
    role: "Game Artist (2D/3D)",
    avatars: avatar6Entry,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Entry",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Support the production of 2D and 3D assets by executing foundational tasks including sketching, base modeling, line work, coloring, UV layout, and cleanup.",
        "Work closely with leads and team members to align with the visual direction and project guidelines. Assist in asset preparation for both illustrative and game-ready use through proper formatting, file organization, and adherence to basic pipelines."
    ],
    coreCapabilities: [
        "Basic skills in sketching, coloring, or 3D blocking and modeling",
        "Understands the fundamentals of art styles, proportions, and composition",
        "Familiar with beginner-friendly tools (e.g., Photoshop, Blender)",
        "Can follow visual references, templates, and project naming conventions",
        "Open to feedback, growth-focused, and detail-attentive"
    ],
    supportedWorkflows:[
        "Works under supervision through task boards like ClickUp or Trello",
        "Participates in basic asset reviews and feedback sessions",
        "Submits deliverables through Google Drive or versioned folders",
        "Supports file naming structure, format compliance, and documentation prep",
        "Collaborates in cross-team check-ins and mentor-guided tasks"
    ],
    keyDeliverables: [
        "Basic sketches or UI/prop concepts (2D): 2 < 4 / week",
        "Low-poly models or shape block-ins (3D): 1 < 2 / week",
        "Color passes / clean-ups / line art: 2 < 3 / task",
        "Basic UV layouts or file exports: 1 < 3 / task",
        "Organized files with proper naming: 90–100% compliance",
        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Supports 2D and 3D asset creation through sketching, modeling, UVs, and file prep under supervision.",   
            "Builds foundational skills in drawing, sculpting, texturing, and using tools like Photoshop, Blender, and Maya.",
            "Submits organized files, applies feedback, and receives mentorship and workflow exposure." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Adobe Photoshop", "Clip Studio Paint", "Paint", "Blender", "Canva"
    ],
    fileFormats: [
        ".PSD", ".PNG", ".JPG", ".FBX", ".BLEND"
    ],
    Plugins: [
        "Basic brush sets", "Symmetry Tools", "UV Helper Plugins"
    ],
    gameType: [
        "Casual", "Stylized", "Mobile"
    ],
    gameEngine: [
        "Basic familiarity with Unity or export-ready requirements"
    ],
    versionControl: [
        "Github", "Google Workspace", "ClickUp"
    ],
    communication: [
        "Responds to supervision and feedback(Slacks, Discord, Microsoft Teams, Gmeet)"
    ],
    workEthic: [
        "Curious", "Adaptable", "Open to Learning", "Consistent", "Timely"
    ],
    hardSkills: [
        "Line art", "Flat Coloring", "Mesh Cleanup", "Basic UV unwrapping"
    ],
    genre: [
        "Fantasy", "Sci-fi", "Cartoony (Depends on Client request in scope)"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Assigned to entry-level asset tasks in both 2D and 3D pipelines",
        "Up to 2–3 revision rounds per deliverable with review guidance",
        "Access to starter templates, naming guides, and sample references",
        "Participates in supervised reviews, onboarding sessions, and internal task syncs",
        "Given exposure to both 2D and 3D team routines to expand skill breadth"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "G-ART(2D/3D)-M",
    role: "Game Artist (2D/3D)",
    avatars: avatar6Mid,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Mid",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Deliver complete 2D and 3D assets aligned with project style guides and technical constraints. Interpret creative briefs independently, applying solid visual fundamentals and production knowledge across modeling, texturing, illustration, and asset preparation. Collaborate across teams to support asset integration and maintain consistency in execution and delivery standards."
    ],
    coreCapabilities: [
        "Proficient in 2D rendering, sculpting, 3D modeling, UV layout, and PBR texturing",
        "Can interpret concept references and translate into polished, reusable game assets",
        "Follows file naming conventions and versioning standards with minimal supervision",
        "Capable of reviewing junior assets and ensuring technical compliance",
        "Works across 2D and 3D pipelines to match engine requirements"
    ],
    supportedWorkflows:[
        "Operates via ClickUp, Trello, or Agile sprint systems for assignments",
        "Submits deliverables through structured cloud or repository-based folders",
        "Joins sprint planning, reviews, and QA check-ins with senior guidance",
        "Collaborates with rigging, animation, and UI teams for integration-ready files",
        "Follows documentation standards and contributes feedback for improvement"
    ],
    keyDeliverables: [
        "Stylized or semi-realistic 2D illustrations or UI/UX sets: 2 < 4 / week",
        "Mid-poly props, characters, or modular kits (3D): 1 < 2 / week",
        "UV layout, material baking, texture passes: 2 < 3 / task",
        "Ready-to-import engine assets (Unity/Unreal): 1 < 2 / week",
        "Cleanly structured, properly named files: 100% compliance",

        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Delivers complete 2D/3D assets independently, participates in art reviews, and ensures visual alignment.",   
            "Proficient in multi-style execution, modular design, and engine-ready packaging for games.",
            "Provides feedback to junior artists, supports documentation, and collaborates across departments." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Adobe Photoshop", "Illustrator", "Clip Studio Paint", "Blender", "Maya", "ZBrush"
    ],
    fileFormats: [
        ".PSD", ".PNG", ".JPG", ".FBX", ".BLEND", ".TIFF", ".OBJ"
    ],
    Plugins: [
        "Lazy Nezumi", "UVPackmaster", "Texel Density Checker", "BrushBox", "DecalMachine"
    ],
    gameType: [
        "Casual", "Stylized", "Mobile", "Semi-realistic", "PC", "VR/AR"
    ],
    gameEngine: [
        "Unity", "Unreal Engine (static mesh, 2D sprite, UI export workflows"
    ],
    versionControl: [
        "Github", "Google Workspace", "ClickUp"
    ],
    communication: [
        "Clear, responsive, actively contributes to critiques and sprint reviews (Discord, Slack and Microsoft Teams)"
    ],
    workEthic: [
        "Consistent", "Detail-Oriented", "Adaptable", "Team-Minded"
    ],
    hardSkills: [
        "Clean Topology", "PBR-Ready texture work", "Layout composition", "Asseet Polish"
    ],
    genre: [
        "Fantasy", "Sci-fi", "Cartoony (Depends on Client request in scope)"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Up to 3–4 feedback passes per asset",
        "Independently handles modular assets, props, UI/UX packages, or illustration sets",
        "Participates in team reviews, critiques, QA tasks, and cross-pipeline coordination",
        "May be requested to mentor entry-level artists and review file structure",
        "Contributes to visual documentation, style references, or asset library improvement"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "G-ART(2D/3D)-S",
    role: "Game Artist (2D/3D)",
    avatars: avatar6Senior,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Senior",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Lead the execution and quality control of 2D and 3D art assets across environments, characters, props, UI, and visual effects. Ensure all outputs meet stylistic direction, engine compatibility, and delivery timelines. Mentor artists at junior and mid-levels, contribute to documentation, and collaborate cross-functionally to maintain asset pipeline consistency and production readiness."
    ],
    coreCapabilities: [
        "Expert in both 2D and 3D workflows, from illustration and UI to sculpting, modeling, and texturing",
        "Strong understanding of optimization, modular systems, and performance-conscious art",
        "Ability to define and maintain style guides, asset templates, and visual direction documents",
        "Comfortable working with technical artists, producers, and developers to align deliveries",
        "Experienced in evaluating work, providing structured feedback, and improving visual pipelines"
    ],
    supportedWorkflows:[
        "Oversees tasks via Agile tools (ClickUp, Trello) and manages team output visibility",
        "Participates in and often leads milestone art reviews, QA checks, and final asset sign-offs",
        "Coordinates file delivery via structured folders (Perforce, Git, GDrive) with full compliance",
        "Collaborates across animation, UI/UX, rigging, and design to ensure visual and technical integration",
        "Updates and maintains documentation such as naming conventions, export guides, and asset checklists"
    ],
    keyDeliverables: [
        "Benchmark 2D and 3D assets (characters, UI kits, environments): 1 < 2 / week",
        "Complex asset systems or visual sets (multi-platform): 1 < 2 / milestone",
        "Mentorship reviews or feedback sessions: Weekly / per artist cycle",
        "Visual documentation or pipeline updates: Per scope or major revision",
        "Final sign-off ready files with full compliance: 100% QA cleared",

        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Leads high-level asset production, provides direction, and drives consistency across 2D and 3D outputs.",   
            "Expert in visual pipelines, cross-functional communication, and scalable asset design for real-time use",
            "Approves assets, mentors teams, and enhances standards and processes through leadership and reviews." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Adobe Suite", "Clip Studio", "Blender", "ZBrush", "Maya", "Substance Painter", "Figma"
    ],
    fileFormats: [
        ".PSD", ".PNG", ".FBX", ".BLEND", ".TIFF", ".OBJ" ,".MA", ".SPSM"
    ],
    Plugins: [
        "Texel Density Checker", "Material Baker", "DecalMachine", "Lazy Nezumi"
    ],
    gameType: [
        "Console", "PC", "VR/AR", "Cross-platform (mobile-support)"
    ],
    gameEngine: [
        "Unity", "Unreal Engine (2D & 3D worflows, lightmap prep, LOD support)"
    ],
    versionControl: [
        "Github", "Google Workspace", "ClickUp", "Perforce"
    ],
    communication: [
        "Leads team check-ins, flags blockers early, and presents visual solutions to clients or leads (Discord, Slack and Microsoft Teams)"
    ],
    workEthic: [
        "Vision-Driven", "Pipeline-Oriented", "Supportive", "Accountable"
    ],
    hardSkills: [
        "Art Direction", "High-resolution sculpting", "UI Design", "Material Setuo", "Render Polish"
    ],
    genre: [
        "Adaptable", "Fantasy", "Sci-fi", "Realistic", "Stylized", "Minimalist"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Oversees visual production, ensuring accuracy, performance, and stylistic quality",
        "Responsible for final sign-offs, peer review cycles, and asset QA",
        "Leads team mentorship, supporting upskilling, feedback sessions, and art onboarding",
        "Participates in client-facing reviews, milestone calls, and cross-discipline syncs",
        "Creates and updates visual guides, style sheets, and internal documentation"
    ],
    deploymentEngagement: [
        " "
    ],
  },
//--------------------------UI-UX-DESIGNER-------------------------------------------------------------------------
{
    talentId: "UI/UX-GEN-E",
    role: "UI/UX (Generalist)",
    avatars: avatar8Entry,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Entry",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Assist in the creation of user interface components under supervision.",
        "Apply basic visual hierarchy and layout principles.",
        "Support in translating wireframes into simple visual mockups.",
        "Learn user-centric design fundamentals and feedback loops.",
        "Participate in design reviews and contribute to iterative tasks."
    ],
    coreCapabilities: [
        "Basic understanding of UI layout, shapes, spacing, and composition.",
        "Familiarity with tools like Figma, Adobe XD, or Sketch.",
        "Willingness to learn best practices in usability and accessibility.",
        "Ability to work with design systems and follow existing style guides.",
        "Accepts and integrates feedback constructively."
    ],
    supportedWorkflows:[
        "Button, icon, and simple HUD mockup design.",
        "Layout assistance based on wireframes or design briefs.",
        "Organizing and naming UI assets and components.",
        "Exporting assets for integration (e.g., PNGs, SVGs).",
        "Documentation of UI elements in libraries or Figma components.",
        "Participation in usability testing sessions (as observer)."
    ],
    keyDeliverables: [
        "Basic UI mockups (buttons, icons, HUD components): 2 < 4 / week",
        "Support on wireframes or layout passes: 1 < 2 / week",
        "Asset exports (PNG, SVG) for engine use: per assigned task",
        "Organized design files (Figma/XD/Sketch): 90%+ compliance",
        "Feedback integration / revisions: 2 < 3 iterations per task",
        "Component tagging and asset library maintenance: per sprint",
        "Participation in usability/playtest sessions: 1 < 2 per milestone",

        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Supports UI creation by applying basic design principles, learning user-focused practices, and contributing to mockups and reviews under guidance.",   
            "Has foundational UI knowledge, uses basic design tools, follows style guides, and shows a strong willingness to learn and improve through feedback.",
            "Assists in creating and organizing UI mockups and assets, supports layout tasks, prepares files for export, and contributes to documentation and testing as a learner." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Figma", "Adobe XD", "Sketch", "Canva (basic)"
    ],
    fileFormats: [
        "PNG", "JPG", "SVG", "PDF", "Figma/Sketch source files"
    ],
    Plugins: [
        "Figma plugins (Iconify, Content Reel)", "Stark (accessibility checker)"
    ],
    gameType: [
        "Mobile", "Web", "Casual"
    ],
    gameEngine: [
        "Unity (intro to UI integration)", "basic export-ready assets"
    ],
    versionControl: [
        "Google Drive", "Notion", "Trello", "Slack"
    ],
    communication: [
        "Slack", "Google Meet", "Zoom", "Microsoft Teams", "Discord"
    ],
    workEthic: [
        "Curiouus", "Responsive", "Detail-oriented", "Eager to learn"
    ],
    hardSkills: [
        "Wireframing", "Layout basics", "Component Creation", "Visual Hierarchy"
    ],
    genre: [
        "Casual", "Minimalist", "Modern", "Fantasy-Lite"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Up to 2–3 feedback iterations per UI asset or layout",
        "Access to style guides, component libraries, and Figma templates",
        "Participation in design reviews and playtest observation",
        "Responsible for basic asset export and documentation tagging",
        "Involved in wireframe translation and mockup layout support"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "UI/UX-GEN-M",
    role: "UI/UX (Generalist)",
    avatars: avatar8Mid,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Mid",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Design intuitive and visually appealing interfaces aligned with game and user goals.",
        "Create wireframes and visual mockups with minimal supervision.",
        "Collaborate with designers, artists, and engineers on user journeys and layout flows.",
        "Participate in UX research and apply results to improve usability.",
    ],
    coreCapabilities: [
        "Proficient in layout design, visual hierarchy, and interactive UI behaviors.",
        "Strong tool knowledge: Figma, Adobe XD, Photoshop, Illustrator.",
        "Can iterate based on usability feedback and design critiques.",
        "Experience creating and managing style guides or UI kits.",
        "Understands responsive/adaptive UI behavior across platforms."
    ],
    supportedWorkflows:[
        "Wireframing and prototyping user journeys.",
        "Creating high-fidelity UI assets and layouts.",
        "Building and maintaining UI component libraries.",
        "Iterative design improvements based on user feedback or A/B testing",
        "Preparing assets for game engine integration (Unity, Unreal).",
        "Working within agile sprints and providing task estimates."
    ],
    keyDeliverables: [
        "Wireframes and user flows (mobile/console/PC): 2 < 3 / sprint",
        "High-fidelity UI assets (screens, pop-ups, HUDs): 2 < 4 / week",
        "Interactive prototypes (Figma, ProtoPie, XD): 1 < 2 / sprint",
        "Design system contributions (tokens, color/typography rules): per update cycle",
        "Asset delivery readiness for Unity/Unreal: 100% compliance",
        "Iteration rounds based on QA/playtest/UX feedback: 1 < 2 / round",
        "Task estimations and agile tracking (Jira/Notion): 100% sprint coverage",

        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Designs user-focused game interfaces with minimal supervision, collaborating across teams to build effective layouts and applying research to enhance usability.",   
            "Skilled in UI layout and interaction design, proficient with design tools, adapts work based on feedback, and manages reusable design systems across platforms.",
            "Produces polished UI designs, prototypes user flows, maintains component libraries, and integrates assets into game engines while working within agile sprints." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Figma", "Adobe XD", "Axure", "Photoshop", "Sketch (iOS)", "Affinity", "Designer (iOS)", "Invision"
    ],
    fileFormats: [
        "PNG", "JPG", "SVG", "PDF", "Figma/Sketch/XD editable files"
    ],
    Plugins: [
        "Contrast", "Autoflow", "Iconify", "Motion", "Content Reel"
    ],
    gameType: [
        "Mobile", "Web", "Midcore"
    ],
    gameEngine: [
        "Unity", "Unreal(UI asset export & style alignment)"
    ],
    versionControl: [
        "Jira", " Confluence", "Notion", "Trello", "Slack", "Git (for asset commits)"
    ],
    communication: [
        "Slack", "Google Meet", "Zoom", "Microsoft Teams", "Discord"
    ],
    workEthic: [
        "Self-driven", "Collaborative", "Problem-solver", "Feedback-responsive"
    ],
    hardSkills: [
        "Prototyping", "Visual Polish", "System Design", "Usability focus"
    ],
    genre: [
        "Sci-Fi", "Stylized", "Fantasy", "Mobile-First", "Cyberpunk"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Handles 3+ feedback rounds and incorporates usability insights",
        "Maintains and expands component libraries and style systems",
        "Collaborates across teams to ensure design-engine alignment",
        "Leads interactive prototype creation and user flow documentation",
        "May participate in usability testing and iterative refinement cycles"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  {
    talentId: "UI/UX-GEN-S",
    role: "UI/UX (Generalist)",
    avatars: avatar8Senior,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Senior",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
        "Drive the overall user interface strategy and visual direction across projects.",
        "Lead the design of cohesive UI/UX systems optimized for player experience.",
        "Collaborate with stakeholders to align design goals with game vision.",
        "Mentor junior and mid-level UI/UX artists and improve internal workflows.",
    ],
    coreCapabilities: [
        "Expert knowledge of interaction design, user psychology, and accessibility standards.",
        "Mastery in tools such as Figma, XD, ProtoPie, and Adobe Creative Suite.",
        "Can lead usability testing, analyze player feedback, and make design decisions.",
        "Skilled in cross-platform UX planning (mobile, console, desktop).",
        "Experience creating documentation for design standards, flows, and best practices."
    ],
    supportedWorkflows:[
        "UI/UX vision-setting and roadmap planning.",
        "High-fidelity prototypes and animated interactions.",
        "Collaboration with game and product teams on feature UI flows.",
        "Conducting user tests and presenting findings to stakeholders.",
        "Documentation of design guidelines, UX patterns, and internal best practices.",
        "Coaching and reviewing work from junior/mid-level teammates."
    ],
    keyDeliverables: [
        "UI/UX frameworks and systems (menus, HUD, nav): 1 < 2 / milestone",
        "Advanced interaction prototypes (motion/UX behaviors): 1 < 2 / sprint",
        "UI/UX documentation (style guides, design specs, flows): per feature/module",
        "UX test plan creation + feedback reporting: 1 per feature/test round",
        "Review & mentorship contributions (redlines, 1:1s, paintovers): weekly",
        "Pipeline/tooling improvements (Figma libraries, engine templates): 1 < 2 / quarter",
        "Cross-platform consistency reviews (console/PC/mobile): per major release",

        "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
            "Leads UI/UX strategy and system design across projects, aligning visual goals with gameplay vision while mentoring the team and enhancing workflows.",   
            "Expert in user behavior, cross-platform design, and accessibility, with mastery of advanced tools and the ability to lead testing and design documentation.",
            "Oversees UI/UX planning, delivers advanced prototypes, drives user testing, documents standards, and mentors junior staff to maintain quality and consistency." 
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Figma", "Adobe XD", "After Effects", "Axure", "Photoshop", "Sketch (iOS)", "Affinity Designer(iOS)", "Invision"
    ],
    fileFormats: [
        "PNG", "SVG", "JSON (UI configs)", "PDFs", "editable files for documentation"
    ],
    Plugins: [
        "Design Lint", "Stark", "Iconify", "Anima", "Figmotion"
    ],
    gameType: [
        "Mobile", "PC", "Console", "Cross-platform"
    ],
    gameEngine: [
        "Unity", "Unreal(blueprint collaboration, mockup integration)"
    ],
    versionControl: [
        "Git", "Github", "Jira", "Confluence", "Notion", "Figma libraries"
    ],
    communication: [
        "Slack", "Google Meet", "Zoom", "Microsoft Teams", "Discord"
    ],
    workEthic: [
        "Visionary", "proactive", "quality-focused", "mentor-minded"
    ],
    hardSkills: [
        "UX research", "motion design", "interaction design", "documentation", "testing UX"
    ],
    genre: [
        "All", "Fantasy", "Sci-Fi", "Realistic", "Stylized", "Hypercasual", "Retro"
    ],
    shiftAvailability: [
        "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
        "Moderate (can adjust for project needs)"
    ],
    inclusions: [
        "Leads UI/UX planning sessions and defines visual strategy per project",
        "Oversees documentation of standards, flow charts, and design guides",
        "Drives user testing, compiles feedback, and translates findings into UI/UX improvements",
        "Mentors junior designers and supervises library/system consistency",
        "Participates in cross-functional alignment with production and art leads"
    ],
    deploymentEngagement: [
        " "
    ],
  },
  //--------------------------UI-UX-DESIGNER-------------------------------------------------------------------------
{
    talentId: "UNITY-ENT-001",
    role: "Unity Developer",
    avatars: avatar9Entry,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Entry",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Tagalog"],
    function: ["Game Development", "Engineering"],
    deploymentModel: ["Remote", "Offshore Dedicated", "Hybrid"],
    price: " ",
    minimumEngagement: "6 months",
    deploymentTimeline: "14 days",
    roleObjective: [
        "To support Unity-based game production by executing assignedtasks with close supervision. Idealfor projects needing affordable, hands-on assistance in basic scripting, prefab setup, and functional testing for casual 2D games or prototypes."
    ],
    coreCapabilities: [
        "Proficient with Unity Editor and basic C# scripting",
        "Prefab-based object manipulation",
        "Basic scene composition and animation triggers",
        "Implements designer-assigned UI and player input scripts.",
    ],
    supportedWorkflows:[
        "Works under lead developer’s supervision",
        "Contributes to sprint tasks for prefabs, triggers, and bug fixes.",
        "Collaborates with QA for early-stage testing and reporting",
    ],
    keyDeliverables: [
        "Basic prefab and UI integration",
        "Static and minimally interactive scenes",
        "Unit-tested components for casual or mobile games",
    ],
    tierSummary: [
            "Basic Unity tasks with clear instructions. Focused on prefab setup, basic UI implementation, and simple interactions.",   
            "Code templating, inspector setup, prefab integration, and UI buttons or animations based on templates.",
            "High supervision required. Follows documented instructions and reports to senior or lead devs." ,
            "Best for early-stage prototypes, internal demos, or as support to existing dev teams.",
            "High supervision required. Follows documented instructions and reports to senior or lead devs."
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "],
    },
    primaryTools: [
        "Unity 2021+", "Visual Studio Code", 
    ],
    fileFormats: [
        ".unity", ".cs", ".fbx", ".png"
    ],
    Plugins: [
        "Cinemachine (basic)", "Unity UI"
    ],
    gameType: [
        "2D Casual", "Puzzle"
    ],
    gameEngine: [
        "Unity"
    ],
    versionControl: [
        " "
    ],
    communication: [
        "Slack", "Discord | Clear on assigned task"
    ],
    workEthic: [
        "Coachable", "Adaptable", "Punctual"
    ],
    hardSkills: [
        "Object Pooling", "Prefab setup"
    ],
    genre: [
        "Arcade", "Runner", "Casual"
    ],
    shiftAvailability: [
        "GMT+8 (adjustable)"
    ],
    workScheduleFlexibility: [
        "Fixed Schedule", "Task-based extensions"
    ],
    inclusions: [
        "Daily Reporting", "Basic source code commits", "Integration with existing team QA pipeline"
    ],
    deploymentEngagement: [
        "NDA compliant", "Supervisor-assisted onboarding", "Free training week included"
    ],
  },
  {
    talentId: "UNITY-MID-002",
    role: "Unity Developer",
    avatars: avatar9Mid, 
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Mid",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Tagalog"],
    function: ["Game Development", "Engineering"],
    deploymentModel: ["Remote", "Offshore Dedicated", "Hybrid"],
    price: " ",
    minimumEngagement: "6 months",
    deploymentTimeline: "14 Days",
    roleObjective: [
        "To independently develop core gameplay features, integrate systems, and refine user experience within the Unity engine. Ideal for clients looking for a stable, mid-tier talent to handle entire feature modules and collaborate with art/design teams."
    ],
    coreCapabilities: [
        "Intermediate-level scripting with C# (event-driven systems, UI logic)",
        "Implements and connects UI, input, physics, and audio components",
        "Proficient in memory profiling, prefab modularity, and optimization",
        "Sets up gameplay loops (missions, quests, score systems)"
    ],
    supportedWorkflows: [
        "Participates in sprint planning and retrospective cycles",
        "Owns tasks with minimal supervision",
        "Works in tandem with artists, designers, and QA for polish and balance"
    ],
    keyDeliverables: [
        "Core mechanics like combat, crafting, or player progression",
        "Mid-level AI behavior and scene transitions",
        "Clean, reusable scripts and prefabs following naming conventions"
    ],
    tierSummary: [
        "Develops self-contained gameplay systems, collaborates across teams, and handles end-to-end delivery of core mechanics.",
        "Builds gameplay loops like scoring, quests, inventory; handles scene transitions and UI logic independently.",
        "Moderate supervision. Owns modules and provides technical input during design. Reports progress in agile sprints.",
        "Ideal for playable vertical slices, advanced demos, or medium-scope client builds.",
        "Delivers meaningful, shippable features. Balances price and functionality. Boosts development speed with reliability."
    ],
    typeofSupport: {
        Call: [" "],
        Chat: [" "]
    },
    primaryTools: [
        "Unity Hub", "Rider", "Visual Studio"
    ],
    fileFormats: [
        ".unity", ".cs", ".json", ".anim"
    ],
    Plugins: [
        "DOTween", "Addressables", "NavMesh", "Cinemachine"
    ],
    gameType: [
        "2D", "3D"
    ],
    gameEngine: [
        "Unity"
    ],
    versionControl: [
        "Git", "GitLab"
    ],
    communication: [
        "Daily standups", "Sprint reviews"
    ],
    workEthic: [
        "Independent", "Quality-focused", "Responsive"
    ],
    hardSkills: [
        "ScriptableObjects", "Unity Events", "Basic async"
    ],
    genre: [
        "Platformers", "RPGs", "Simulation"
    ],
    shiftAvailability: [
        "Client timezone overlap (up to 4 hours)"
    ],
    workScheduleFlexibility: [
        "Core hours with sprint-based extensions"
    ],
    inclusions: [
        "Mid-sprint demos", "Performance reports", "Codebase modularity audits"
    ],
    deploymentEngagement: [
        "IP rights compliance", "Dedicated project handoff", "Optional weekend buffer for revisions"
    ]
  },
  {
  talentId: "UNITY-SNR-003",
  role: "Unity Developer",
  avatars: avatar9Senior, // swap to whatever avatar var you use for Senior
  supportType: " ",
  supportTypeAvailable: " ",
  talentLevel: "Senior",
  talentLevelAvailable: ["Entry", "Mid", "Senior"],
  language: ["English", "Tagalog"],
  function: ["Game Development", "Engineering"],
  deploymentModel: ["Remote", "Offshore Dedicated", "Hybrid"],
  price: " ",
  minimumEngagement: "6 months",
  deploymentTimeline: "14 Days",

  roleObjective: [
    "To lead Unity architecture and optimize game systems across platforms. Best suited for clients targeting commercial release, multiplayer networking, pipeline integration, or needing a mentor to guide engineers and maintain long-term scalability."
  ],

  coreCapabilities: [
    "Advanced Unity expertise (SOLID patterns, async systems, ECS/Jobs)",
    "Full-stack gameplay systems design (networking, cross-platform UI)",
    "Profiling and optimization across CPU/GPU/memory",
    "API & SDK integration (Firebase, Ads, Analytics, multiplayer backends)"
  ],

  supportedWorkflows: [
    "Leads agile planning and technical task scoping",
    "Conducts code reviews and mentoring",
    "Manages build pipeline automation, instrumentation, and data reporting",
    "Aligns technical scope with business goals with product owners/producers"
  ],

  keyDeliverables: [
    "Production-ready gameplay systems and developer tools",
    "Multiplayer/networked features with scalable architecture",
    "Optimization & profiling reports across CPU/GPU/memory"
  ],

  tierSummary: [
    "Oversees and architects full gameplay systems; optimizes builds.",
    "Implements multiplayer logic, addressables, scene loading optimizations, and dev tools. Delivers production-ready systems.",
    "Works independently. Leads planning and reviews. Advises clients on tech direction and scope risk.",
    "Ideal for feature-rich releases, multiplayer titles, VR, and sustained liveops.",
    "Represents tech leadership and deep expertise to ensure long-term success and maintainability."
  ],

  typeofSupport: {
    Call: [" "],
    Chat: [" "]
  },

  primaryTools: ["Unity Pro", "Rider", "Unity Cloud"],
  fileFormats: ["C# scripts", "Custom shaders", "SDK packages", ".json"],

  Plugins: ["Addressables", "NavMesh", "DOTween Pro", "Cinemachine"],
  gameType: ["3D", "Multiplayer", "VR-ready"],
  gameEngine: ["Unity (URP/HDRP)"],

  versionControl: ["GitFlow", "Jenkins", "Bitbucket"],

  communication: [
    "Client calls, dev reviews, retrospectives",
    "Stakeholder updates / mentor-capable"
  ],

  workEthic: ["Vision-driven", "Strong ownership", "Proactive"],

  hardSkills: [
    "Async/Tasks",
    "C# Job System & Burst",
    "Custom shaders",
    "Addressables",
    "Scene loading & state machines"
  ],

  genre: ["FPS", "MMORPG", "Strategy"],

  shiftAvailability: ["Client timezone overlap (core hours)"],
  workScheduleFlexibility: ["High — includes milestone hours"],

  inclusions: [
    "Team mentorship",
    "Build & deployment automation",
    "DevOps and CI/CD integrations"
  ],

  deploymentEngagement: [
    "Full ownership contract",
    "Embedded with client roadmap",
    "Lead-integrator level onboarding"
  ]
},
//---------Player Safety & Moderation Support-------------
{
  talentId: "EXD-SMS-PLAYER-VCT-T1",
  role: "Player Safety & Moderation Support",
  avatars: avatar10Entry, // placeholder variable name
  supportType: "Voice | Chat | Email",
  supportTypeAvailable: "Voice | Chat | Email",
  talentLevel: "Tier 1",
  talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
  language: ["English (B2+)", "Filipino"],
  function: ["Player Safety", "Moderation Queue"],
  deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
  price: " ",
  minimumEngagement: "6 Months",
  deploymentTimeline: " ",

  roleObjective: [
    "To uphold community safety and enforce platform rules by reviewing in-game reports, moderating low-severity violations, and executing predefined actions such as chat restrictions, content flags, or user warnings. Ensures fair and timely application of policies while escalating high-risk behavior to Tier 2."
  ],

  coreCapabilities: [
    "Reviewing and validating player behavior reports",
    "Tagging and escalating flagged violations beyond Tier 1 scope",
    "Enforcing chat, naming, or content-related penalties using approved tools",
    "Maintaining objective judgment and documentation accuracy",
    "Responding to basic moderation-related player inquiries",
    "Identifying false or abusive reporting patterns",
    "Applying enforcement based on clearly defined policies",
    "Operating with neutrality and community protection in mind"
  ],

  supportedWorkflows: [
    "Chat violations (spam, profanity, low-risk harassment)",
    "Inappropriate player names or avatars",
    "User-generated content reviews (within visual/reporting limits)",
    "In-game behavior warnings and temporary silences",
    "Automated system flag review (e.g., profanity filter alerts)",
    "Validating first-time offense cases using templates",
    "Logging actions and submitting reports to QA / moderation leads",
    "Escalating repeat or ambiguous violations to Tier 2 for review"
  ],

  keyDeliverables: [
    "≥ 90% Moderation Accuracy Score (internal QA audits)",
    "≥ 95% Correctness in case logging & tagging",
    "≥ 85% Internal CSAT from moderation leadership",
    "≤ 5% Misrouted or incomplete escalation rate",
    "≥ 45 moderation tickets reviewed daily (standard 8-hour shift)",
    "≤ 12 minutes average handling time per case",
    "Note: These Metrics align with Tier 1 moderation for casual to mid-volume environments; targets may adjust based on live traffic & community size."
  ],

  tierSummary: [
    "Executes rule-based moderation on low-risk or first-offense reports; applies system-defined penalties; forwards unclear/high-risk incidents to higher tiers. Handles first-time or low-severity behavior reports.",
    "Executes predefined moderation actions using clear violation rules. Handles first-time or low-severity behavior reports."
  ],

  typeofSupport: {
    Chat: [
      "Handles basic player moderation inquiries or clarification on community policies."
    ],
    InGame: [
      "Main tool for receiving/reviewing behavior reports and executing in-platform actions."
    ],
    Email: [
      "Used for follow-ups on warnings, suspension outcomes, or internal incident documentation."
    ]
  },

  primaryTools: [
    "Moderation Dashboards",
    "In-Game Admin Tools",
    "Zoho Desk",
    "Zendesk",
    "Freshdesk",
    "Google Workspace",
    "CRM-linked moderation logs"
  ],

  fileFormats: [
    "JPG",
    "PNG",
    "TXT",
    "Screenshot logs",
    "Moderation templates",
    "Timestamped chat excerpts"
  ],

  Plugins: [
    "Client-approved moderation interface tools only",
    "No backend plugin usage",
    "No system modification privileges"
  ],

  gameType: [
    "Mobile",
    "Browser",
    "Lightweight PC or Console titles"
  ],

  gameEngine: [
    "No direct engine access; familiar with in-game reporting and chat moderation features within Unity, Unreal, or proprietary platforms"
  ],

  versionControl: [
    "Slack",
    "Microsoft Teams",
    "Zoho Cliq",
    "Internal ticket routing",
    "Moderation QA dashboards",
    "No Git or repo access"
  ],

  communication: [
    "Objective", "brand-neutral tone",
    "Non-escalatory phrasing",
    "Policy-backed responses",
    "Consistent with global trust & safety language"
  ],

  workEthic: [
    "Impartial",
    "Discreet",
    "Policy-compliant",
    "Detail-oriented",
    "Emotionally steady",
    "Ethical in judgment"
  ],

  hardSkills: [
    "Moderation workflow familiarity",
    "CRM navigation",
    "Violation tagging",
    "Incident audit logging",
    "Typing speed ≥ 40 WPM"
  ],

  genre: [
    "Social",
    "Casual",
    "MMO",
    "Sandbox",
    "Simulation",
    "PvP Lite"
  ],

  shiftAvailability: [
    "Day",
    "Night",
    "Weekend",
    "Holiday",
    "LiveOps-aligned moderation rotation"
  ],

  workScheduleFlexibility: [
    "Live event moderation coverage",
    "Real-time community escalation handling",
    "Peak hour moderation support",
    "Weekly moderation rotation readiness"
  ],

  inclusions: [
    " "
  ],

  deploymentEngagement: [
    " "
  ]
},

{
  talentId: "EXD-SMS-PLAYER-VCT-T3",
  role: "Player Safety & Moderation Support",
  avatars: avatar10Senior,
  supportType: "Voice | Chat | Email",
  supportTypeAvailable: "Voice | Chat | Email",
  talentLevel: "Tier 3",
  talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
  language: ["English (B2+)", "Filipino"],
  function: ["Player Safety", "Moderation Queue"],
  deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
  price: " ",
  minimumEngagement: "6 Months",
  deploymentTimeline: " ",
  roleObjective: [
    "To investigate high-risk safety incidents, systemic abuse patterns, and platform-level moderation escalations.",
    "Tier 3 agents operate as the highest enforcement layer—resolving legal-sensitive reports, coordinating with compliance or legal teams, and protecting player communities from coordinated or emergent threats to platform integrity."
  ],
  coreCapabilities: [
    "Deep-dive review of incident logs, system abuse patterns, and cross-platform user behavior",
    "Reviewing legal-risk reports, harassment escalations, and Terms of Service violations",
    "Collaborating with compliance, policy, or legal departments on user bans and platform actions",
    "Drafting post-incident reviews, de-escalation timelines, and enforcement reports",
    "Identifying vulnerabilities in reporting systems or moderation gaps",
    "Handling mass report events, targeted harassment, and coordinated abuse",
    "Reviewing flagged edge cases from Tier 2 and determining final resolutions",
    "Monitoring emerging safety threats and flagging community-impact risks"
  ],
  supportedWorkflows: [
    "Investigation of user ban evasion, impersonation, and multi-account abuse",
    "Coordinated harassment or raid incident triage",
    "Real-time escalation of abuse spikes or platform exploitation",
    "Review of flagged moderation cases, appeals, or reversals",
    "Handling high-profile user enforcement cases or partner-related moderation",
    "Systemic abuse audit for vulnerabilities in automated flagging tools",
    "Communication with compliance on data reporting, law-enforcement cooperation, or community safety escalations",
    "Development of policy notes and precedent-setting internal moderation guidelines"
  ],
  keyDeliverables: [
    "≥ 95% Accuracy in Case Review and Resolution Logs",
    "≥ 98% Policy & Legal Compliance in Final Enforcement Actions",
    "≥ 90% Risk Escalation Turnaround within SLA",
    "≤ 1% Post-Resolution Reopen Rate",
    "≥ 8 Critical Risk Cases Closed Weekly (varies by complexity)",
    "≤ 72 Hours Resolution Cycle for Tier 3 Tickets (priority-based)",
    "Note: Tier 3 KPIs focus on platform trust, legal risk management, and long-term community-health metrics."
  ],
  tierSummary: [
    "Handles policy edge cases, large-scale abuse, legal escalations, and platform-level threats. Works in partnership with compliance, legal, and safety oversight units.",
    "Investigates systemic violations, coordinated platform abuse, and sensitive enforcement cases. Operates in coordination with policy, legal, or executive review."
  ],
  typeofSupport: {
    Chat: ["Used to collaborate with internal moderation and trust units in real-time."],
    InGameReportingTools: ["Reviewed as part of cross-incident audit chains or to trace escalation trends."],
    Email: ["Primary medium for formal moderation decisions, legal correspondence, and documentation of high-risk cases."]
  },
  primaryTools: [
    "Advanced Moderation Consoles", "Incident Audit Systems", "Jira", "Zoho Desk",
    "Google Workspace", "Slack", "Compliance Dashboards", "Abuse Pattern Analysis Tools", "Legal Escalation Trackers"
  ],
  fileFormats: [
    "PDF", "CSV", "Screenshot logs", "Chat transcripts", "Moderation reports",
    "Case review templates", "Incident debrief documents"
  ],
  Plugins: [
    "Limited to secure, client-authorized review systems",
    "No plugin development / Read-only access to audit or enforcement dashboards"
  ],
  gameType: ["Cross-platform", "MMO", "Competitive PvP", "Social Sandbox Games"],
  gameEngine: [
    "No direct access to engines; understanding of how chat/reporting systems function within Unity, Unreal, or proprietary frameworks"
  ],
  versionControl: [
    "Slack", "Microsoft Teams", "Jira", "Zoho Cliq", "Shared moderation war rooms",
    "Legal & policy documentation tools", "No direct Git or codebase access"
  ],
  communication: [
    "Audit-compliant / Legally safe", "Documentation-focused", "Objective in enforcement rationale",
    "Policy-aligned without compromising clarity"
  ],
  workEthic: [
    "Highly discreet", "Legal-compliant", "Crisis-resilient", "Policy-aware",
    "Systems-level thinker", "Trusted with high-impact cases"
  ],
  hardSkills: [
    "Case audit traceability", "Risk analysis", "Policy enforcement reporting",
    "Data log navigation", "Legal escalation documentation", "Typing speed ≥ 45 WPM"
  ],
  genre: ["RPG", "MOBA", "Competitive Shooter", "Large-Scale Simulation", "Community-Driven Environments"],
  shiftAvailability: [
    "24×7 coverage for incident escalation", "Legal response windows",
    "Weekend & holiday readiness for platform integrity"
  ],
  workScheduleFlexibility: [
    "Crisis-mode response", "Rapid abuse-spike coordination",
    "Trust & Safety rotation readiness", "Policy update rollouts / system failure reviews"
  ],
  inclusions: [],
  deploymentEngagement: []
},
{
    talentId: "EXD-SMS-PLAYER-VCT-T1",
    role: "Player Safety & Moderation Support",
    avatars: avatar10Mid, // placeholder variable name
    supportType: "Voice | Chat | Email",
    supportTypeAvailable: "Voice | Chat | Email",
    talentLevel: "Tier 2",
    talentLevelAvailable: ["Tier 1", "Tier 2", "Tier 3"],
    language: ["English (B2+)", "Filipino"],
    function: ["Player Safety", "Moderation Queue"],
    deploymentModel: ["Offshore On-Demand Talent", "Dedicated Offshore Team"],
    price: " ",
    minimumEngagement: "6 Months",
    deploymentTimeline: " ",
  
    roleObjective: [
      "To uphold community safety and enforce platform rules by reviewing in-game reports, moderating low-severity violations, and executing predefined actions such as chat restrictions, content flags, or user warnings. Ensures fair and timely application of policies while escalating high-risk behavior to Tier 2."
    ],
  
    coreCapabilities: [
      "Reviewing and validating player behavior reports",
      "Tagging and escalating flagged violations beyond Tier 1 scope",
      "Enforcing chat, naming, or content-related penalties using approved tools",
      "Maintaining objective judgment and documentation accuracy",
      "Responding to basic moderation-related player inquiries",
      "Identifying false or abusive reporting patterns",
      "Applying enforcement based on clearly defined policies",
      "Operating with neutrality and community protection in mind"
    ],
  
    supportedWorkflows: [
      "Chat violations (spam, profanity, low-risk harassment)",
      "Inappropriate player names or avatars",
      "User-generated content reviews (within visual/reporting limits)",
      "In-game behavior warnings and temporary silences",
      "Automated system flag review (e.g., profanity filter alerts)",
      "Validating first-time offense cases using templates",
      "Logging actions and submitting reports to QA / moderation leads",
      "Escalating repeat or ambiguous violations to Tier 2 for review"
    ],
  
    keyDeliverables: [
      "≥ 90% Moderation Accuracy Score (internal QA audits)",
      "≥ 95% Correctness in case logging & tagging",
      "≥ 85% Internal CSAT from moderation leadership",
      "≤ 5% Misrouted or incomplete escalation rate",
      "≥ 45 moderation tickets reviewed daily (standard 8-hour shift)",
      "≤ 12 minutes average handling time per case",
      "Note: These Metrics align with Tier 1 moderation for casual to mid-volume environments; targets may adjust based on live traffic & community size."
    ],
  
    tierSummary: [
      "Executes rule-based moderation on low-risk or first-offense reports; applies system-defined penalties; forwards unclear/high-risk incidents to higher tiers. Handles first-time or low-severity behavior reports.",
      "Executes predefined moderation actions using clear violation rules. Handles first-time or low-severity behavior reports."
    ],
  
    typeofSupport: {
      Chat: [
        "Handles basic player moderation inquiries or clarification on community policies."
      ],
      InGame: [
        "Main tool for receiving/reviewing behavior reports and executing in-platform actions."
      ],
      Email: [
        "Used for follow-ups on warnings, suspension outcomes, or internal incident documentation."
      ]
    },
  
    primaryTools: [
      "Moderation Dashboards",
      "In-Game Admin Tools",
      "Zoho Desk",
      "Zendesk",
      "Freshdesk",
      "Google Workspace",
      "CRM-linked moderation logs"
    ],
  
    fileFormats: [
      "JPG",
      "PNG",
      "TXT",
      "Screenshot logs",
      "Moderation templates",
      "Timestamped chat excerpts"
    ],
  
    Plugins: [
      "Client-approved moderation interface tools only",
      "No backend plugin usage",
      "No system modification privileges"
    ],
  
    gameType: [
      "Mobile",
      "Browser",
      "Lightweight PC or Console titles"
    ],
  
    gameEngine: [
      "No direct engine access; familiar with in-game reporting and chat moderation features within Unity, Unreal, or proprietary platforms"
    ],
  
    versionControl: [
      "Slack",
      "Microsoft Teams",
      "Zoho Cliq",
      "Internal ticket routing",
      "Moderation QA dashboards",
      "No Git or repo access"
    ],
  
    communication: [
      "Objective", "brand-neutral tone",
      "Non-escalatory phrasing",
      "Policy-backed responses",
      "Consistent with global trust & safety language"
    ],
  
    workEthic: [
      "Impartial",
      "Discreet",
      "Policy-compliant",
      "Detail-oriented",
      "Emotionally steady",
      "Ethical in judgment"
    ],
  
    hardSkills: [
      "Moderation workflow familiarity",
      "CRM navigation",
      "Violation tagging",
      "Incident audit logging",
      "Typing speed ≥ 40 WPM"
    ],
  
    genre: [
      "Social",
      "Casual",
      "MMO",
      "Sandbox",
      "Simulation",
      "PvP Lite"
    ],
  
    shiftAvailability: [
      "Day",
      "Night",
      "Weekend",
      "Holiday",
      "LiveOps-aligned moderation rotation"
    ],
  
    workScheduleFlexibility: [
      "Live event moderation coverage",
      "Real-time community escalation handling",
      "Peak hour moderation support",
      "Weekly moderation rotation readiness"
    ],
  
    inclusions: [
      " "
    ],
  
    deploymentEngagement: [
      " "
    ]
  },
//-----------2D Artist Generalist-------------
{
  talentId: "2D-GEN-E",
  role: "2D Artist (Generalist)",
  avatars: avatar7Entry,
  supportType: " ",
  supportTypeAvailable: " ",
  talentLevel: "Entry",
  talentLevelAvailable: ["Entry", "Mid", "Senior"],
  language: ["English", "Filipino", "Bisaya"],
  function: ["Creative", "Art Team"],
  deploymentModel: ["Remote"],
  price: " ",
  minimumEngagement: " ",
  deploymentTimeline: " ",
  roleObjective: [
    "Assist in the production of 2D art assets under supervision.",
    "Learn and apply basic techniques in line with project style guides.",
    "Support the art team by preparing draft versions of assets.",
    "Respond positively to feedback and demonstrate consistent improvement.",
    "Participate in team reviews and development planning sessions."
  ],
  coreCapabilities: [
    "Foundational drawing skills: shapes, proportions, and color application.",
    "Basic proficiency in digital painting tools (e.g., Photoshop, Clip Studio Paint).",
    "Willingness to learn asset creation techniques and pipeline standards.",
    "Attentive to detail and open to continuous skill development.",
    "Ability to follow art direction and receive feedback constructively.",
    "Basic understanding of organizing layers and preparing files for team use.",
  ],
  supportedWorkflows: [
    "Sketching, thumbnailing, and rendering simple illustrations.",
    "Asset cleanup and preparation of deliverables (e.g., organizing PSD layers).",
    "Support in color fills, line art refinement, and revisions.",
    "Shadowing senior artists and participating in mentorship tasks.",
    "Exposure to version control, asset naming conventions, and pipeline documentation.",
  ],
  keyDeliverables: [
    "Thumbnail sketches: 2 < 4 / week",
    "Flat-colored assets (props, icons, basic illustrations): 1 < 2 / week",
    "Revision rounds per asset: 2 < 3",
    "Organized PSD submissions: 90%+ compliance",
    "Mentored task completions (with review): 1 < 3 / week",

    "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
  ],
  tierSummary: [
    "Supports asset production through guided tasks, learns core techniques, responds well to feedback, and grows through participation in team planning and reviews.",
    "Has foundational drawing and tool skills, demonstrates eagerness to learn pipelines, follows direction, and contributes to asset preparation with attention to detail.",
    "Assists with basic sketching, cleanup, color support, and task organization, while gradually gaining exposure to version control and workflow documentation under mentorship."
  ],
  typeofSupport: {
    Call: [""] ,
    Chat: [""],
  },
  primaryTools: [
    "Adobe Photoshop", "Clip Studio Paint", "Illustrator"
  ],
  fileFormats: [
    "PSD", "PNG", "JPG", "TIFF", "SVG", "GIF"
  ],
  Plugins: [
    "Perspective Tools", "Coolorus", "MagicPicker", "Lazy Nezumi", "BrushBox"
  ],
  gameType: ["Mobile", "PC", "Console", "Web-based", "Casual", "Midcore", "Hardcore"],
  gameEngine: [
    "Familiarity with Unity (basic asset export)"
  ],
  versionControl: [
    "Figma", "Jira", "Miro", "Google Workspace"
  ],
  communication: [
    "Slack", "Google Meet", "Zoom", "Microsoft Teams", "Discord"
  ],
  workEthic: [
    "Eager to learn", "Disciplined", "Receptive", "Detail-Focused", "Collaborative"
  ],
  hardSkills: [
    "Sketching", "Base Coloring", "Cleanup", "Layer Management", "Artistic Consistency"
  ],
  genre: ["Casual", "Stylized", "Light Fantasy", "Light Sci-Fi"],
  shiftAvailability: [
    "Day Shift", "Partial overlapping hours for feedback loops"
  ],
  workScheduleFlexibility: [
    "Moderate (can adjust for project needs)"
  ],
  inclusions: ["Completion of mentored sketching and coloring tasks",
    "Up to 2-3 revision rounds per asset based on art lead feedback",
    "Access to art guidelines, layer structure samples, and PSD standards",
    "Participation in review meetings and art team huddles",
    "Assigned task include  thumbnailing, coloring, cleanup, and file prep",
    "Guided exposure to version control and workflow tools (Jira, Miro, GDrive)"
  ],
  deploymentEngagement: []
},
{
    talentId: "2D-GEN-M",
    role: "2D Artist (Generalist)",
    avatars: avatar7Mid,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Mid",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
      "Independently create high-quality 2D art assets that align with the game’s visual style.",
      "Collaborate with team members including designers and senior artists to ensure cohesive visuals.",
      "Assist in interpreting briefs into visual outputs with minimal supervision.",
      "Follow established art guidelines and pipelines while offering creative solutions.",
      "Participate in reviews, incorporating feedback efficiently into revisions."
    ],
    coreCapabilities: [
      "Strong drawing fundamentals: composition, lighting, anatomy, and perspective.",
      "Proficiency in tools like Adobe Photoshop and Clip Studio Paint.",
      "Good understanding of visual style matching and consistency.",
      "Capable of delivering assets from concept to final polish.",
      "Ability to take direction and iterate based on feedback.",
      "Effective collaboration with both art and cross-functional teams.",
    ],
    supportedWorkflows: [
      "Asset production (characters, props, environments) following direction.",
      "Texture painting, color blocking, and iteration based on feedback.",
      "Thumbnailing and concept sketches.",
      "File preparation for development (cleaned, layered PSDs).",
      "Participation in sprint planning, asset tracking, and internal reviews.",
      "Art QA support and version updates."
    ],
    keyDeliverables: [
      "Thumbnail and concept sketches: 2 < 5 / week",
      "Polished 2D assets (characters, props, backgrounds): 2 < 3 / week",
      "Revision rounds per asset: 1 < 2",
      "Organized PSD submissions: 95%+ compliance",
      "Task ownership (independent delivery): 3 < 5 / sprint",
  
      "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
      "Produces polished 2D assets aligned with visual direction, collaborates with senior team members, and interprets briefs into quality outputs with minimal supervision while adhering to guidelines and contributing to team reviews.",
      "Demonstrates strong artistic fundamentals and proficiency in tools, consistently delivers refined assets, adapts to feedback, and collaborates effectively across departments with a clear grasp of visual style.",
      "Executes character and prop art production, handles texture work and revisions, prepares organized deliverables, participates in agile workflows, and supports internal reviews and asset quality control."
    ],
    typeofSupport: {
      Call: [""] ,
      Chat: [""],
    },
    primaryTools: [
      "Adobe Photoshop", "Clip Studio Paint", "Illustrator"
    ],
    fileFormats: [
      "PSD", "PNG", "JPG", "TIFF", "SVG", "GIF"
    ],
    Plugins: [
      "Perspective Tools", "Coolorus", "MagicPicker", "Lazy Nezumi", "BrushBox"
    ],
    gameType: ["Mobile", "Web-based", "Casual"],
    gameEngine: [
      "Unity", "Unreal Engine (for art asset integration, not UI)"
    ],
    versionControl: [
      "Figma", "Jira", "Miro", "Google Workspace"
    ],
    communication: [
      "Slack", "Google Meet", "Zoom", "Microsoft Teams", "Discord"
    ],
    workEthic: [
      "Reliable", "Adaptable", "Takes Initiative", "Responsive to Feedback"
    ],
    hardSkills: [
      "2D Illustration", "Asset Polish", "Shape Design", "Lighting", "Color Rendering"
    ],
    genre: ["Fantasy", "Casual", "Stylized", "Sci-Fi"],
    shiftAvailability: [
      "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
      "Moderate (can adjust for project needs)"
    ],
    inclusions: ["Expected to deliver polished illustrations and layered assets",
      "Responsible for 3+ feedback iterations and team collaboration cycles",
      "Participation in sprint reviews, internal critiques, and feedback loops",
      "Assigned full scenes, props, or UI elements with minimal supervision",
      "Involvement in revisions and optimization of previously submitted art",
      "Contributes to art library updates and documentation"
    ],
    deploymentEngagement: []
  },
  {
    talentId: "2D-GEN-S",
    role: "2D Artist (Generalist)",
    avatars: avatar7Senior,
    supportType: " ",
    supportTypeAvailable: " ",
    talentLevel: "Senior",
    talentLevelAvailable: ["Entry", "Mid", "Senior"],
    language: ["English", "Filipino", "Bisaya"],
    function: ["Creative", "Art Team"],
    deploymentModel: ["Remote"],
    price: " ",
    minimumEngagement: " ",
    deploymentTimeline: " ",
    roleObjective: [
      "Lead the conceptualization and execution of high-quality 2D assets aligned with game style and design direction.",
      "Collaborate closely with Art Directors and Game Designers to define visual aesthetics.",
      "Provide art direction and mentoring to junior and mid-level artists.",
      "Innovate and standardize production pipelines to improve efficiency and asset consistency.",
      "Proactively identify artistic or production bottlenecks and recommend strategic solutions."
    ],
    coreCapabilities: [
      "Advanced proficiency in digital illustration, concept art, and visual storytelling.",
      "Strong understanding of anatomy, perspective, lighting, and composition.",
      "Mastery in Adobe Photoshop, Clip Studio Paint, or equivalent software.",
      "Excellent collaboration and communication skills in a multi-disciplinary team.",
      "Capable of interpreting feedback constructively and applying it effectively.",
      "Familiarity with production schedules, task scoping, and asset optimization.",
    ],
    supportedWorkflows: [
      "Concept art development (characters, environments, props)",
      "UI/UX asset creation and polish",
      "Marketing materials and key visual production",
      "Asset iteration, version control, and team review cycles",
      "Integration of assets into Unity/Unreal with proper naming and organization",
      "Art bible creation and documentation for visual alignment"
    ],
    keyDeliverables: [
      "High-quality asset sets (character/prop/environment themes): 1 < 2 / sprint",
      "Art direction tasks (feedback rounds, redlines, reviews): 3 < 5 / week",
      "Documentation updates (style guides, art bibles): 1 < 2 / sprint",
      "Pipeline/process improvements proposed: 1 < 2 / quarter",
      "Organized PSDs and team consistency audits: 100% compliance",
  
      "Note: These deliverables are subject to change based on client requirements, project scope, and task volume."
    ],
    tierSummary: [
      "Leads the creation of top-quality 2D game assets, defines visual direction with stakeholders, mentors junior artists, and improves pipelines to boost consistency and efficiency across the art team.",
      "Demonstrates expert-level skill in illustration and concept art, strong grasp of visual fundamentals, mastery of tools, clear communication, and the ability to apply feedback and manage scoped tasks independently.",
      "Owns concept art production, marketing visuals, version control cycles, asset integration in game engines, and documentation of visual standards — ensuring alignment across all project visuals. (UI/UX excluded)."
    ],
    typeofSupport: {
      Call: [""] ,
      Chat: [""],
    },
    primaryTools: [
      "Adobe Photoshop", "Clip Studio Paint", "Illustrator", "Spine", "Live2D Cubism"
    ],
    fileFormats: [
      "PSD", "PNG", "JPG", "TIFF", "SVG", "GIF"
    ],
    Plugins: [
      "Perspective Tools", "Coolorus", "MagicPicker", "Lazy Nezumi", "BrushBox"
    ],
    gameType: ["Mobile", "Web-based", "Casual", "PC", "Console", "Midcore", "Hardcore"],
    gameEngine: [
      "Unity", "Unreal Engine (for art asset integration, not UI)"
    ],
    versionControl: [
      "Git", "Perforce", "Plastic SCM", "Trello", "Asana", "Jira", "Notion", "Google Workspace", "Slack"
    ],
    communication: [
      "Slack", "Google Meet", "Zoom", "Microsoft Teams", "Discord"
    ],
    workEthic: [
      "Detail-Oriented", "Autonomous", "Problem-Solver", "Consistent Quality Output", "Team-First Mindset"
    ],
    hardSkills: [
      "Concept Art", "Character/Environment Design", "Prop Design", "Color Theory", "Art Direction", "Art Pipeline"
    ],
    genre: ["Fantasy", "Sci-Fi", "Realistic", "Stylized", "Anime-inspired", "Cyberpunk", "Historical"
    ],
    shiftAvailability: [
      "Day Shift", "Partial overlapping hours for feedback loops"
    ],
    workScheduleFlexibility: [
      "Moderate (can adjust for project needs)"
    ],
    inclusions: ["Oversees and approves final 2D visuals before project delivery",
      "Leads internal reviews, visual direction alignment, and cross-team feedback",
      "Produces key visual content, marketing art, and style-defining elements",
      "Supports art pipeline documentation and consistency across projects",
      "Mentors junior artists and supports quality assurance across outputs",
      "May coordinate with project managers for milestone planning and asset pacing"
    ],
    deploymentEngagement: []
  },
];

export default role;
